import React from "react";
import { useNavigate } from "react-router-dom";
import { Button, Grid } from "@mui/material";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
// import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import PercentSharpIcon from "@mui/icons-material/PercentSharp";
import { useEffect } from "react";
import swal from "sweetalert";
import { makeGetRequest, makePostRequest } from "../../../utils/utils";
import dayjs from "dayjs";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import moment from "moment";
// import CreateInvoiceWithTab from "./CreateInvoiceWithTab";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
    maintenence_type: index,
  };
}

function TabForCreateInvoice(props) {
  const navigate = useNavigate();
  const [value, setValue] = React.useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const [showLoader, setShowLoader] = React.useState(false);
  const [ownersList, setOwnersList] = React.useState([]);
  const [apartmentList, setApartmentList] = React.useState([]);
  const [q, setQ] = React.useState("");
  const [selectedOwner, setSelectedOwner] = React.useState("");
  const [selectedApartment, setSelectedApartment] = React.useState("");
  // const [ownerData, setOwnerData] = React.useState({});
  const [invoiceNo, setInvoiceNo] = React.useState(0);
  const [invoice_date, setInvoiceDate] = React.useState(dayjs(new Date()));
  const [due_date, setDueDate] = React.useState(invoice_date.add(15, "day"));
  const [subject, setSubject] = React.useState();
  const [invoiceType, setInvoiceType] = React.useState("Monthly Maintenance");
  const [billto, setBillTo] = React.useState("");
  const [, setWing] = React.useState("");
  const [apartmentNo, setApartmentNo] = React.useState("");
  const [contactNo, setContactNo] = React.useState("");
  const [emailId, setEmailId] = React.useState("");
  const [notes, setNotes] = React.useState("");
  const [note] = React.useState("");
  // const [cgst, setCgst] = React.useState(10);
  // const [sgst, setSgst] = React.useState(10);
  // const [cgstAmt, setCgstAmt] = React.useState(0);
  // const [sgstAmt, setSgstAmt] = React.useState(0);
  const [subTotal, setSubTotal] = React.useState(0);
  const [advanceReceived, setAdvanceReceived] = React.useState(0);
  const [past_due, setPastDue] = React.useState(0);
  const [lateFee, setLateFee] = React.useState(0);
  const [totalPayable, setTotalPayable] = React.useState(0);
  const [hiddentotalPayable, setHiddenTotalPayable] = React.useState(0);
  const [hiddenmisstotalPayable, setHiddenMissTotalPayable] = React.useState(0);
  // const [maintenenceIdList, setMaintenenceIdList] = React.useState([]);
  const [maintenenceList, setMaintenenceList] = React.useState([
    {
      maintenence_id: "",
      maintenence_type: "",
      amount: "",
      is_active: "",
      created_at: "",
      updated_at: "",
      is_deleted: "",
    },
  ]);
  const [maintenenceJsonList, setMaintenenceJsonList] = React.useState([]);
  const [mischJsonList, setMischJsonList] = React.useState([
    { name: "", amount: "", duration_key: "", duration: "", total: "" },
  ]);

  // const [maintenencemissJsonList, setMaintenenceMissJsonList] = React.useState(
  //   []
  // );

  const [otherJsonList, setOtherJsonList] = React.useState([
    {
      maintenence_id: "",
      maintenence_type: "",
      amount: "",
      is_active: "",
      created_at: "",
      updated_at: "",
      is_deleted: "",
    },
  ]);
  // const [selectedDurationForAmt, SetSelectedDurationForAmt] =
  //   React.useState("");
  // const [selectedDuration, SetSelectedDuration] = React.useState("");
  const [taxList, setTaxList] = React.useState([]);
  // const [amenitiesList, setAmenitiesList] = React.useState([]);
  const [amenitiesJsonList] = React.useState([]);
  // const [selectedAmenity, setSelectedAmenity] = React.useState("");
  const [selectedAmenityName] = React.useState("");
  const [amount] = React.useState(0);
  // const [noOfDays, setNoOfDays] = React.useState(0);
  // const [total, setTotal] = React.useState(0);
  // const [arr_amount, setArr_amount] = React.useState("");
  // const [arr_noOfDays, setArr_noOfDays] = React.useState();
  // const [arr_tot_Charges, setArr_tot_Charges] = React.useState();
  const [showEmailToTenantMessage, setShowEmailToTenantMessage] =
    React.useState(false);
  const [, setIsSendEmailToTenant] = React.useState(false);
  const [, setTenantEmailId] = React.useState("");

  let mainteneceJson;
  const [maintenenceTotal, setMaintenenceTotal] = React.useState(0);
  const [, setTaxTotal] = React.useState(0);

  let taxJson;
  const [taxJsonList, SetTaxJsonList] = React.useState([]);
  const [maintenenceLength, setMaintenenceLength] = React.useState(0);

  const [fcmToken, setFcmToken] = React.useState("");
  const [createInvoiceFalg, setCreateInvoiceFalg] = React.useState(null);

  const [residentid, setresidentid] = React.useState();
  // const [current_date, setcurrent_date] = React.useState(dayjs(new Date()));
  const getAddedMaintenence = (e) => {};

  //=========================================================================

  const handleMaintenencevalue = (event, index) => {
    let data = [...maintenenceList];
    data[index].maintenence_type = event.target.value;
    setMaintenenceList(data);
    console.log(data);
  };

  const handleEditMaintenencevalue = (event, index) => {
    let data = [...maintenenceJsonList];
    data[index].key = event.target.value;
    setMaintenenceJsonList(data);
    console.log(data);
  };

  const handleOtherMaintenencevalue = (event, index) => {
    // alert("hi")
    let data1 = [...otherJsonList];
    data1[index].maintenence_type = event.target.value;
    setOtherJsonList(data1);
  };

  const handleUservalueChange = (event, index) => {
    let data = [...maintenenceList];
    data[index].amount = event.target.value
      .replace(/[^0-9.]/g, "")
      .replace(/(\..*?)\..*/g, "$1")
      .replace(/(\.\d{2}).+/g, "$1");
    setMaintenenceList(data);
    console.log("first xxx >>>", data);
  };

  // const handleEditLatefee = async (e,index) => {
  //   console.log(index)
  //   // let data = [...maintenenceList];
  //   // data[index].amount = event.target.value.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1').replace(/(\.\d{2}).+/g, '$1');
  //   // setMaintenenceList(data);
  //   // console.log("first xxx >>>",data)

  //   let data = [...taxList];
  //   data[index].tax_amount = e.target.value.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1').replace(/(\.\d{2}).+/g, '$1');
  //   setTaxList(data);
  //   console.log("first xxx >>>",data)

  // }

  //=========================================================================
  //Abhay

  function numbertaxfloat(event, index, taxtitle) {
    let val = event.target.value;
    if (val > 0) {
      let data = [...taxJsonList];
      let newperTotal = (maintenenceTotal * val) / 100;
      data[index].value = val;
      data[index].total = newperTotal;
      if (taxtitle == "Late Fee") {
        setLateFee(newperTotal);
      }
      SetTaxJsonList(data);
      setTimeout(() => caltaxcalamt(event, index), 300);
    } else {
      let data = [...taxJsonList];
      data[index].value = 0;
      data[index].total = 0;
      if (taxtitle == "Late Fee") {
        setLateFee(0);
      }
      SetTaxJsonList(data);
      setTimeout(() => caltaxcalamt(event, index), 300);
    }
  }

  const handleTaxMaintenances = (event, index) => {
    let data = [...taxJsonList];
    data[index].value = event.target.value;
    SetTaxJsonList(data);
  };

  async function caltaxcalamt(event, index, opt) {
    let totamt = 0;
    let taxtotamt = 0;
    let inputs = document.getElementsByTagName("input");
    let totamt_Array = [];
    let taxtotamt_Array = [];
    let cnt_Array = 0;
    let taxcnt_Array = 0;
    let x = 0;
    for (let i = 0; i < inputs.length; i++) {
      if (inputs.item(i).getAttribute("name") == "amount") {
        totamt_Array.push(inputs.item(i));
        cnt_Array++;
      }

      if (inputs.item(i).getAttribute("name") == "taxcalamts") {
        taxtotamt_Array.push(inputs.item(i));
        taxcnt_Array++;
      }
    }

    for (let h = 0; h < cnt_Array; h++) {
      let priceval = parseFloat(totamt_Array[h].value);

      if (priceval) {
        if (priceval < 0) {
          totamt_Array[h].value = 0;
        } else {
          totamt = totamt + priceval;
        }
      } else {
        totamt_Array[h].value = 0;
      }
    }

    var txtsubtot = totamt.toFixed(2);
    document.getElementById("subTotal").innerHTML = txtsubtot;
    document.getElementById("totalPayable").value = txtsubtot;

    setSubTotal(txtsubtot);
    let adv = document.getElementById("advanceReceived").value;
    let newtot = 0;
    var txtPayTotal = document.getElementById("totalPayable").value;

    if (parseFloat(adv) <= parseFloat(txtPayTotal)) {
      newtot = parseFloat(txtPayTotal) - parseFloat(adv);
    } else {
      alert("Please enter valid amount");
      setAdvanceReceived(0);
      newtot = txtPayTotal;
    }

    for (let h = 0; h < taxcnt_Array; h++) {
      let taxpriceval = parseFloat(taxtotamt_Array[h].value);

      if (taxpriceval) {
        if (taxpriceval < 0) {
          taxtotamt_Array[h].value = 0;
        } else {
          taxtotamt = taxtotamt + taxpriceval;
        }
      } else {
        taxtotamt_Array[h].value = 0;
      }
    }

    let newtaxwithamount = taxtotamt + totamt;

    // setMaintenenceTotal(newtaxwithamount);

    let tototal = parseFloat(newtaxwithamount);

    let lessadvanceamt = 0;

    if (newtaxwithamount >= adv) {
      setTotalPayable(newtaxwithamount - adv);
      lessadvanceamt = newtaxwithamount - adv;
    } else {
      setTotalPayable(newtaxwithamount - 0);
      lessadvanceamt = newtaxwithamount;
    }

    setTotalPayable(parseFloat(lessadvanceamt).toFixed(2));
    setHiddenTotalPayable(parseFloat(tototal).toFixed(2));
  }

  //=============================================================================

  // for misch

  function numbertaxfloatmis(event, index, taxtitle) {
    let val = event.target.value;

    if (val > 0) {
      console.log("taxJsonList", taxJsonList);
      let data = [...taxJsonList];
      let newperTotal = (maintenenceTotal * val) / 100;
      data[index].value = val;
      data[index].total = newperTotal;
      if (taxtitle == "Late Fee") {
        setLateFee(newperTotal);
      }
      SetTaxJsonList(data);
      setTimeout(() => calmisstaxcalamt(event, index), 300);
    } else {
      let data = [...taxJsonList];
      data[index].value = 0;
      data[index].total = 0;
      if (taxtitle == "Late Fee") {
        setLateFee(0);
      }
      SetTaxJsonList(data);
      setTimeout(() => calmisstaxcalamt(event, index), 300);
    }
  }

  const handleTaxMaintenancesmis = (event, index) => {
    let data = [...taxJsonList];
    data[index].value = event.target.value;
    SetTaxJsonList(data);
  };

  async function calmisstaxcalamt(event, index, opt) {
    let totamt = 0;
    let taxtotamt = 0;
    let inputs = document.getElementsByTagName("input");
    let totamt_Array = [];
    let taxtotamt_Array = [];
    let cnt_Array = 0;
    let taxcnt_Array = 0;
    let x = 0;
    for (let i = 0; i < inputs.length; i++) {
      if (inputs.item(i).getAttribute("name") == "total") {
        totamt_Array.push(inputs.item(i));
        cnt_Array++;
      }

      if (inputs.item(i).getAttribute("name") == "taxcalamts") {
        taxtotamt_Array.push(inputs.item(i));
        taxcnt_Array++;
      }
    }

    for (let h = 0; h < cnt_Array; h++) {
      let priceval = parseFloat(totamt_Array[h].value);

      if (priceval) {
        if (priceval < 0) {
          totamt_Array[h].value = 0;
        } else {
          totamt = totamt + priceval;
        }
      } else {
        totamt_Array[h].value = 0;
      }
    }

    var txtsubtot = totamt.toFixed(2);
    document.getElementById("subTotal").innerHTML = txtsubtot;
    document.getElementById("totalPayable").value = txtsubtot;
    setSubTotal(txtsubtot);
    let adv = document.getElementById("advanceReceived").value;
    let newtot = 0;
    var txtPayTotal = document.getElementById("totalPayable").value;

    if (parseFloat(adv) <= parseFloat(txtPayTotal)) {
      newtot = parseFloat(txtPayTotal) - parseFloat(adv);
    } else {
      alert("Please enter valid amount");
      setAdvanceReceived(0);
      newtot = txtPayTotal;
    }

    for (let h = 0; h < taxcnt_Array; h++) {
      let taxpriceval = parseFloat(taxtotamt_Array[h].value);

      if (taxpriceval) {
        if (taxpriceval < 0) {
          taxtotamt_Array[h].value = 0;
        } else {
          taxtotamt = taxtotamt + taxpriceval;
        }
      } else {
        taxtotamt_Array[h].value = 0;
      }
    }

    let newtaxwithamount = taxtotamt + totamt;

    // setMaintenenceTotal(newtaxwithamount);

    let tototal = parseFloat(newtaxwithamount);

    let lessadvanceamt = 0;

    if (newtaxwithamount >= adv) {
      setTotalPayable(newtaxwithamount - adv);
      lessadvanceamt = newtaxwithamount - adv;
    } else {
      setTotalPayable(newtaxwithamount - 0);
      lessadvanceamt = newtaxwithamount;
    }

    setTotalPayable(parseFloat(lessadvanceamt).toFixed(2));
    setHiddenMissTotalPayable(parseFloat(tototal).toFixed(2));
  }

  const handleEditUservalueChange = (event, index) => {
    let data = [...maintenenceJsonList];
    data[index].value = event.target.value
      .replace(/[^0-9.]/g, "")
      .replace(/(\..*?)\..*/g, "$1")
      .replace(/(\.\d{2}).+/g, "$1");
    setMaintenenceJsonList(data);
  };

  const handleOthervalueChange = (event, index) => {
    let data = [...otherJsonList];
    data[index].amount = event.target.value
      .replace(/[^0-9.]/g, "")
      .replace(/(\..*?)\..*/g, "$1")
      .replace(/(\.\d{2}).+/g, "$1");
    setOtherJsonList(data);
  };

  const handleadvanceChange = (event) => {
    setAdvanceReceived(event.target.value);
  };

  function numberfloat(event, index) {
    let val = event.target.value;
    if (val > 0) {
      let data = [...maintenenceList];
      data[index].amount = parseFloat(val).toFixed(2);
      setMaintenenceList(data);
    }
  }

  function numberEditfloat(event, index) {
    let val = event.target.value;
    if (val > 0) {
      let data = [...maintenenceJsonList];
      data[index].value = parseFloat(val).toFixed(2);
      setMaintenenceJsonList(data);
    }
  }

  function numbertofloat(event, index) {
    let val = event.target.value;
    if (val > 0) {
      let data = [...otherJsonList];
      data[index].amount = parseFloat(val).toFixed(2);
      setOtherJsonList(data);
    }
  }

  function numbertodecimal(event, index) {
    let val = event.target.value;
    if (val > 0) {
      let data = [...mischJsonList];
      data[index].amount = parseFloat(val).toFixed(2);
      setMischJsonList(data);
    }
  }

  function numberdecimal(event) {
    let val = event.target.value;
    if (val > 0) {
      let convertedValue = parseFloat(val).toFixed(2);
      setAdvanceReceived(convertedValue);
    }
  }

  async function calEditamt(event, index) {
    let totamt = 0;
    let inputs = document.getElementsByTagName("input");
    let totamt_Array = [];
    let cnt_Array = 0;

    for (let i = 0; i < inputs.length; i++) {
      if (inputs.item(i).getAttribute("name") == "value") {
        totamt_Array.push(inputs.item(i));
        cnt_Array++;
      }

      if (inputs.item(i).getAttribute("name") == "amount") {
        totamt_Array.push(inputs.item(i));
        cnt_Array++;
      }
    }

    for (let h = 0; h < cnt_Array; h++) {
      let priceval = parseFloat(totamt_Array[h].value);

      if (priceval) {
        if (priceval < 0) {
          totamt_Array[h].value = 0;
        } else {
          totamt = totamt + priceval;
        }
      } else {
        totamt_Array[h].value = 0;
      }
    }

    var txtsubtot = totamt.toFixed(2);
    document.getElementById("subTotal").innerHTML = txtsubtot;
    document.getElementById("totalPayable").value = txtsubtot;
    setSubTotal(txtsubtot);
    let adv = document.getElementById("advanceReceived").value;
    let newtot = 0;
    var txtPayTotal = document.getElementById("totalPayable").value;

    if (parseFloat(adv) <= parseFloat(txtPayTotal)) {
      newtot = parseFloat(txtPayTotal) - parseFloat(adv);
    } else {
      alert("Please enter valid amount");
      newtot = txtPayTotal;
    }

    let invoiceType = "Monthly Maintenance";
    var selectedApartment = document.getElementById("selectApartdrop").value;
    setSelectedApartment(selectedApartment);

    if (invoiceType == "Monthly Maintenance") {
      SetTaxJsonList([]);
      TaxListing();

      while (taxJsonList.length > 0) {
        taxJsonList.pop();
      }

      var total = document.getElementById("subTotal").innerHTML;

      for (var i = 0; i < apartmentList.length; i++) {
        if (apartmentList[i].apartment_id == selectedApartment) {
          var apartmentObj = apartmentList[i];
          setApartmentNo(apartmentObj.uniq_apt_name);

          var tax = 0;
          var previousMonthTotPayable = 0;
          
          for (var k = 0; k < taxList.length; k++) {
            taxJson = { key: "", value: "", total: "" };

            var calculatedTax;
            if (taxList[k].tax_name === "Late Fee") {
              let latefeeAmt = taxList[k].tax_amount;
              let previousInvoice = "";
              setShowLoader(true);
              await makeGetRequest(
                "invoice/getpreviousmonth/" +
                  selectedOwner +
                  "/" +
                  selectedApartment,
                ""
              )
                .then((response) => {
                  if (response.status == "201") {
                    previousInvoice = response.data.data;
                  }
                })
                .catch((err) => {
                  swal("There was an error!", "more error details", "warning");
                  setShowLoader(false);
                });

              if (previousInvoice) {
                if (previousInvoice.is_paid) {
                  if (
                    new Date(previousInvoice.paid_date).getTime() >
                    new Date(previousInvoice.due_date).getTime()
                  ) {
                    var calculated_lateFee =
                      ((previousInvoice.total_payment -
                        previousInvoice.advance_received) *
                        latefeeAmt) /
                      100;
                    taxList[k].calculatedTax = calculated_lateFee;
                    tax = tax + calculated_lateFee;
                    setLateFee(calculated_lateFee);
                  }
                } else {
                  let calculated_lateFee =
                    ((previousInvoice.total_payment -
                      previousInvoice.advance_received) *
                      taxList[k].tax_amount) /
                    100;
                  taxList[k].calculatedTax = calculated_lateFee;
                  tax = tax + calculated_lateFee;

                  previousMonthTotPayable = previousInvoice.total_payment;
                  setPastDue(previousMonthTotPayable);
                  setLateFee(calculated_lateFee);
                }
              } else taxList[k].calculatedTax = 0;
            } else {
              calculatedTax = (total * taxList[k].tax_amount) / 100;
              taxList[k].calculatedTax = calculatedTax;
              tax = tax + calculatedTax;
            }
            taxJson.key = taxList[k].tax_name;
            taxJson.value = taxList[k].tax_amount;
            taxJson.total = taxList[k].calculatedTax;
            taxJsonList.push(taxJson);
          }
          console.log("taxJsonList", taxJsonList);
          SetTaxJsonList(taxJsonList);
          setMaintenenceTotal(total);
          setTaxTotal(tax);
          setSubTotal(total);
          setTotalPayable(total - advanceReceived + tax);
          let tototal = parseFloat(total) + parseFloat(tax);
          setHiddenTotalPayable(parseFloat(tototal).toFixed(2));
          setShowLoader(false);
        }
      }
    }
  }

  async function newcheck(event, index, editflag) {
    if (editflag) calEditamt(event, index);
    else calqtyamt(event, index);
  }

  async function calqtyamt(event, index) {
    let totamt = 0;
    let inputs = document.getElementsByTagName("input");
    let totamt_Array = [];
    let cnt_Array = 0;

    for (let i = 0; i < inputs.length; i++) {
      if (inputs.item(i).getAttribute("name") == "amount") {
        totamt_Array.push(inputs.item(i));
        cnt_Array++;
      }
    }

    for (let h = 0; h < cnt_Array; h++) {
      let priceval = parseFloat(totamt_Array[h].value);

      if (priceval) {
        if (priceval < 0) {
          totamt_Array[h].value = 0;
        } else {
          totamt = totamt + priceval;
        }
      } else {
        totamt_Array[h].value = 0;
      }
    }

    var txtsubtot = totamt.toFixed(2);
    document.getElementById("subTotal").innerHTML = txtsubtot;
    document.getElementById("totalPayable").value = txtsubtot;
    setSubTotal(txtsubtot);
    let adv = document.getElementById("advanceReceived").value;
    let newtot = 0;
    var txtPayTotal = document.getElementById("totalPayable").value;

    if (parseFloat(adv) <= parseFloat(txtPayTotal)) {
      newtot = parseFloat(txtPayTotal) - parseFloat(adv);
    } else {
      alert("Please enter valid amount");
      newtot = txtPayTotal;
    }

    let invoiceType = "Monthly Maintenance";
    var selectedApartment = document.getElementById("selectApartdrop").value;
    setSelectedApartment(selectedApartment);
    TaxListing();
    if (invoiceType == "Monthly Maintenance") {
      SetTaxJsonList([]);
      while (taxJsonList.length > 0) {
        taxJsonList.pop();
      }

      var total = document.getElementById("subTotal").innerHTML;

      for (var i = 0; i < apartmentList.length; i++) {
        if (apartmentList[i].apartment_id == selectedApartment) {
          var apartmentObj = apartmentList[i];
          setApartmentNo(apartmentObj.uniq_apt_name);

          var tax = 0;
          var previousMonthTotPayable = 0;

          for (var k = 0; k < taxList.length; k++) {
            taxJson = { key: "", value: "", total: "" };

            var calculatedTax;
            if (taxList[k].tax_name === "Late Fee") {
              let latefeeAmt = taxList[k].tax_amount;
              let previousInvoice = "";
              setShowLoader(true);
              await makeGetRequest(
                "invoice/getpreviousmonth/" +
                  selectedOwner +
                  "/" +
                  selectedApartment,
                ""
              )
                .then((response) => {
                  if (response.status == "201") {
                    previousInvoice = response.data.data;
                  }
                })
                .catch((err) => {
                  swal("There was an error!", "more error details", "warning");
                  setShowLoader(false);
                });

              if (previousInvoice) {
                if (previousInvoice.is_paid) {
                  if (
                    new Date(previousInvoice.paid_date).getTime() >
                    new Date(previousInvoice.due_date).getTime()
                  ) {
                    var calculated_lateFee =
                      ((previousInvoice.total_payment -
                        previousInvoice.advance_received) *
                        latefeeAmt) /
                      100;
                    taxList[k].calculatedTax = calculated_lateFee;
                    tax = tax + calculated_lateFee;
                    setLateFee(calculated_lateFee);
                  }
                } else {
                  let calculated_lateFee =
                    ((previousInvoice.total_payment -
                      previousInvoice.advance_received) *
                      taxList[k].tax_amount) /
                    100;
                  taxList[k].calculatedTax = calculated_lateFee;
                  tax = tax + calculated_lateFee;

                  previousMonthTotPayable = previousInvoice.total_payment;
                  setPastDue(previousMonthTotPayable);
                  setLateFee(calculated_lateFee);
                }
              } else taxList[k].calculatedTax = 0;
            } else {
              calculatedTax = (total * taxList[k].tax_amount) / 100;
              taxList[k].calculatedTax = calculatedTax;
              tax = tax + calculatedTax;
            }
            taxJson.key = taxList[k].tax_name;
            taxJson.value = taxList[k].tax_amount;
            taxJson.total = taxList[k].calculatedTax;
            taxJsonList.push(taxJson);
          }

          SetTaxJsonList(taxJsonList);
          setMaintenenceTotal(total);
          setTaxTotal(tax);
          setSubTotal(total);
          setTotalPayable(total - advanceReceived + tax);
          let tototal = parseFloat(total) + parseFloat(tax);
          setHiddenTotalPayable(parseFloat(tototal).toFixed(2));
          setShowLoader(false);
        }
      }
    }
  }

  async function showcalqtyamt(selectedOwner, selectedApartment, type) {
    let bodyFormData = {};

    await makeGetRequest("tax/getallbystatus/true", bodyFormData)
      .then((response) => {
        if (response.status == "201") {
          const data = response.data.data;
          setTaxList(data);

          let invoiceType = "Monthly Maintenance";
          if (invoiceType == "Monthly Maintenance") {
            SetTaxJsonList([]);
            while (taxJsonList.length > 0) {
              taxJsonList.pop();
            }

            var total = document.getElementById("subTotal").innerHTML;
            var tax = 0;
            var previousMonthTotPayable = 0;

            for (var k = 0; k < response.data.data.length; k++) {
              taxJson = { key: "", value: "", total: "" };

              var calculatedTax;
              if (response.data.data[k].tax_name === "Late Fee") {
                let latefeeAmt = response.data.data[k].tax_amount;
                let previousInvoice = "";
                setShowLoader(true);
                makeGetRequest(
                  "invoice/getpreviousmonth/" +
                    selectedOwner +
                    "/" +
                    selectedApartment,
                  ""
                )
                  .then((response) => {
                    if (response.status == "201") {
                      previousInvoice = response.data.data;
                    }
                  })
                  .catch((err) => {
                    swal(
                      "There was an error!",
                      "more error details",
                      "warning"
                    );
                    setShowLoader(false);
                  });

                if (previousInvoice) {
                  if (previousInvoice.is_paid) {
                    if (
                      new Date(previousInvoice.paid_date).getTime() >
                      new Date(previousInvoice.due_date).getTime()
                    ) {
                      var calculated_lateFee =
                        ((previousInvoice.total_payment -
                          previousInvoice.advance_received) *
                          latefeeAmt) /
                        100;
                      response.data.data[k].calculatedTax = calculated_lateFee;
                      tax = tax + calculated_lateFee;
                      setLateFee(calculated_lateFee);
                    }
                  } else {
                    let calculated_lateFee =
                      ((previousInvoice.total_payment -
                        previousInvoice.advance_received) *
                        response.data.data[k].tax_amount) /
                      100;
                    response.data.data[k].calculatedTax = calculated_lateFee;
                    tax = tax + calculated_lateFee;

                    previousMonthTotPayable = previousInvoice.total_payment;
                    setPastDue(previousMonthTotPayable);
                    setLateFee(calculated_lateFee);
                  }
                } else response.data.data[k].calculatedTax = 0;
              } else {
                calculatedTax =
                  (total * response.data.data[k].tax_amount) / 100;
                response.data.data[k].calculatedTax = calculatedTax;
                tax = tax + calculatedTax;
              }
              taxJson.key = response.data.data[k].tax_name;
              taxJson.value = response.data.data[k].tax_amount;
              taxJson.total = response.data.data[k].calculatedTax;
              taxJsonList.push(taxJson);
            }
            let totalamt = parseFloat(total).toFixed(2);
            SetTaxJsonList(taxJsonList);
            setMaintenenceTotal(totalamt);
            // setTaxTotal(tax);
            // setSubTotal(total);
            // setTotalPayable(total - advanceReceived + tax);
            // let tototal = parseFloat(total)+parseFloat(tax);
            // setHiddenTotalPayable(parseFloat(tototal).toFixed(2));
            setShowLoader(false);
            //}
            //}
          }
        } else {
          swal("There was an error!", response.message, "warning");
        }
      })
      .catch((err) => {
        swal("There was an error!", "more error details", "warning");
      });
  }

  function advanceamt(event) {
    let txtsubtot = document.getElementById("subTotal").innerHTML;
    var txtPayTotal = document.getElementById("hiddentotalPayable").value;
    let advance = 0;
    if (event.target.value == "") {
      advance = 0;
    } else {
      advance = event.target.value;
    }

    if (parseFloat(advance) <= parseFloat(txtPayTotal)) {
      let finaltot = parseFloat(txtPayTotal) - parseFloat(advance);
      let finaltotal = finaltot.toFixed(2);
      setTotalPayable(finaltotal);
    } else {
      alert("Please enter valid advance amount");
      setAdvanceReceived(0);
      setTotalPayable(txtPayTotal);
    }
  }

  //=======================================================================================

  const Validation_Schema = Yup.object().shape({
    subject: Yup.string().required("Required"),
    // .matches(
    //   /^([A-Za-z\u00C0-\u00D6\u00D8-\u00f6\u00f8-\u00ff\s]*)$/gi,
    //   "Numbers not allowed!!"
    // )
  });

  var formikInitials = {
    subject: subject,
    note: note,
  };

  async function OwnerListing(q) {
    let bodyFormData = {
      searchq: q,
    };
    setShowLoader(true);
    await makePostRequest("resident/getall", bodyFormData)
      .then((response) => {
        if (response.status == "201") {
          const data = response.data.data;
          setOwnersList(data);
        } else {
          swal("There was an error!", response.message, "warning");
        }
        setShowLoader(false);
      })
      .catch((err) => {
        setShowLoader(false);
        swal("There was an error!", "more error details", "warning");
      });
  }

  async function MaintenenceListing() {
    let bodyFormData = {};
    setShowLoader(true);
    await makeGetRequest("maintenence/getallbystatus/true", bodyFormData)
      .then((response) => {
        if (response.status == "201") {
          setMaintenenceLength(response.data.data.length);
          const data = response.data.data;
          setMaintenenceList(data);

          let x = 0;
          data.map((i, index) => {
            x = x + data[index].amount;
            setMaintenenceTotal(parseFloat(x).toFixed(2));
            setSubTotal(parseFloat(x).toFixed(2));
            setTotalPayable(parseFloat(x).toFixed(2));
            setHiddenTotalPayable(parseFloat(x).toFixed(2));
          });
          console.log("first", data);
        } else {
          swal("There was an error!", response.message, "warning");
        }
        setShowLoader(false);
      })
      .catch((err) => {
        setShowLoader(false);
        swal("There was an error!", "more error details", "warning");
      });
  }

  async function handlechangeOwner(residentId) {
    setresidentid(residentId)

    if (residentId > 0) {
      setSelectedOwner(residentId);
      setShowLoader(true);
      await makeGetRequest("resident/getalldetails/" + residentId, "")
        .then((response) => {
          if (response.status == "201") {
            const data = response.data.data;
            console.log("Apartment Response ");
            console.log('fcm',response.data.data.fcm_token);
            setApartmentList(response.data.apartmentList);
            setBillTo(data.user_obj.first_name + " " + data.user_obj.last_name);
            setEmailId(data.user_obj.email_id);
            setContactNo(data.user_obj.contact_no);
            if(data.fcm_token) {
              setFcmToken(data.fcm_token)
            } else {
              setFcmToken("")
            }
            
          } else {
            swal("There was an error!", response.message, "warning");
          }
          setShowLoader(false);
        })
        .catch((err) => {
          setShowLoader(false);
          swal("There was an error!", "more error details", "warning");
        });
    } else {
      setSelectedOwner("");
    }
  }

  async function handleChangeTabs(invoiceType) {
    setInvoiceType(invoiceType);
    if (invoiceType == "Monthly Maintenance") {
      window.location.reload();
    } else {
      setShowLoader(true);
      setSelectedOwner("");
      setSelectedApartment("");
      setBillTo("");
      setWing("");
      setApartmentNo("");
      setContactNo("");
      setEmailId("");
      setShowEmailToTenantMessage(false);
      setIsSendEmailToTenant(false);
      setTenantEmailId("");
      setMaintenenceTotal(0);
      setSubTotal(0);
      setTotalPayable(0);
      setAdvanceReceived(0);
      setNotes("");
      let bodyFormData = {
        status: "true",
        invoiceType: invoiceType,
      };
      makePostRequest("bankdetails/getallbystatus", bodyFormData)
        .then((response) => {
          if (response.status == "201") {
            const data = response.data.data;

            console.log(data.length);
            if (response.data.data.length) {
              setShowLoader(false);
            } else {
              setShowLoader(false);
              swal(
                "Please Configure Invoice Settings",
                "Bank Details for Mischellenious Invoice not configured",
                "warning",
                {
                  timer: 5000,
                  buttons: false,
                }
              );

              navigate("/InvoiceSettings");
            }
            setShowLoader(false);
          }
        })
        .catch((err) => {
          setShowLoader(false);
          swal("There was an error!", "more error details", "warning");
        });
    }
  }

  async function handleeditchangeApartment(selectedApartmentId, invoiceType) {
    var selectedApartment = selectedApartmentId;
    setSelectedApartment(selectedApartmentId);

    // var skillsSelect = document.getElementById("selectApartdrop");
    // var selectedText = skillsSelect.options[skillsSelect.selectedIndex].text;
    // console.log("first",);
  }

  async function handlechangeApartment(selectedApartmentId, invoiceType) {
    var selectedApartment = selectedApartmentId;
    setSelectedApartment(selectedApartmentId);
    TaxListing();
    SetTaxJsonList([]);
    while (taxJsonList.length > 0) {
      taxJsonList.pop();
    }

    if (invoiceType == "Monthly Maintenance") {
      var total = document.getElementById("subTotal").innerHTML;
      console.log(total);
      for (var i = 0; i < apartmentList.length; i++) {
        if (apartmentList[i].apartment_id == selectedApartment) {
          var apartmentObj = apartmentList[i];
          setApartmentNo(apartmentObj.uniq_apt_name);

          var tax = 0;
          var previousMonthTotPayable = 0;
          for (var k = 0; k < taxList.length; k++) {
            taxJson = { key: "", value: "", total: "" };

            var calculatedTax;
            if (taxList[k].tax_name === "Late Fee") {
              let latefeeAmt = taxList[k].tax_amount;
              // let latefeeAmt = 0; //change for late fee 0
              let previousInvoice = "";

              await makeGetRequest(
                "invoice/getpreviousmonth/" +
                  selectedOwner +
                  "/" +
                  selectedApartment,
                ""
              )
                .then((response) => {
                  if (response.status == "201") {
                    previousInvoice = response.data.data;

                    // for chk prev
                    console.log("on aprt ch test inv", response.data.data);
                  }
                })
                .catch((err) => {
                  swal("There was an error!", "more error details", "warning");
                });

              if (previousInvoice) {
                
                if (previousInvoice.is_paid) {
                  if (
                    new Date(previousInvoice.paid_date).getTime() >
                    new Date(previousInvoice.due_date).getTime()
                  ) {
                   
                    var calculated_lateFee =
                      ((previousInvoice.total_payment -
                        previousInvoice.advance_received) *
                        latefeeAmt) /
                      100;
                    taxList[k].calculatedTax = calculated_lateFee;
                    tax = tax + calculated_lateFee;
                    setLateFee(calculated_lateFee);
                  }
                } else {
                  
                  // let calculated_lateFee =
                  //   ((previousInvoice.total_payment - previousInvoice.advance_received) * taxList[k].tax_amount) / 100;

                  //change for late fee 0
                  let calculated_lateFee =
                    ((previousInvoice.total_payment -
                      previousInvoice.advance_received) *
                      0) /
                    100;
                  taxList[k].calculatedTax = calculated_lateFee;
                  tax = tax + calculated_lateFee;

                  previousMonthTotPayable = previousInvoice.total_payment;
                  setPastDue(previousMonthTotPayable);
                  setLateFee(calculated_lateFee);
                  console.log("setPastDue", previousMonthTotPayable);
                  console.log("setPastDue", calculated_lateFee);
                }
              } else taxList[k].calculatedTax = 0;
            } else {
              calculatedTax = (total * taxList[k].tax_amount) / 100;
              taxList[k].calculatedTax = calculatedTax;
              tax = tax + calculatedTax;
            }
            taxJson.key = taxList[k].tax_name;
            // taxJson.value = taxList[k].tax_amount;

            //Abhay
            if (taxList[k].calculatedTax == 0) {
              taxJson.value = 0;
            } else {
              taxJson.value = taxList[k].tax_amount;
            }

            //Abhay
            taxJson.total = taxList[k].calculatedTax;
            taxJsonList.push(taxJson);
          }
          console.log("taxJsonList", taxJsonList);

          SetTaxJsonList(taxJsonList);
          setMaintenenceTotal(total);
          setTaxTotal(tax);
          setSubTotal(total);

          let taxwithtotal = parseFloat(total) + parseFloat(tax);
          if (parseFloat(advanceReceived) <= parseFloat(taxwithtotal)) {
            let actualtotal =
              parseFloat(taxwithtotal) - parseFloat(advanceReceived);
            setTotalPayable(actualtotal);
          } else {
            setTotalPayable(taxwithtotal);
            setAdvanceReceived(0);
          }

          let tototal = parseFloat(total) + parseFloat(tax);
          setHiddenTotalPayable(parseFloat(tototal).toFixed(2));
        }
      }
    } else if (invoiceType == "Miscellaneous") {
    }
  }

  // For Date Picker
  const [value1, setValue1] = React.useState(new dayjs());

  // const handleInvoiceDate = async(newValue) => {
  //   setInvoiceDate(newValue);
  //   setDueDate(invoice_date.add(1, "month")); 
  // };

  const handleInvoiceDate = async(newValue) => {
    setInvoiceDate(newValue);
    setDueDate(invoice_date.add(1, "month"));
    if(invoiceType==="Monthly Maintenance") {
    await checkuniqueinvoice(newValue, selectedApartment, residentid); 
    }
    console.log("in dt",createInvoiceFalg)
  };

  const handleDueDate = (newValue) => {
    if (newValue >= invoice_date) {
      setDueDate(newValue);
    } else {
      swal(
        "Invalid Date!",
        "please select a date greater than start date of Invoice",
        "warning"
      );
    }
  };
  // End

  async function TaxListing() {
    let bodyFormData = {};

    await makeGetRequest("tax/getallbystatus/true", bodyFormData)
      .then((response) => {
        if (response.status == "201") {
          const data = response.data.data;
          setTaxList(data);
        } else {
          swal("There was an error!", response.message, "warning");
        }
      })
      .catch((err) => {
        swal("There was an error!", "more error details", "warning");
      });
  }


 

  
  
 
  async function saveInvoice() {
    console.log('flg 1', createInvoiceFalg);
   
    // await checkuniqueinvoice();
    console.log('flg 222', createInvoiceFalg);
    
    if (invoice_date && due_date && selectedOwner && selectedApartment) {
      console.log('flg',createInvoiceFalg)
      // if (!createInvoiceFalg) {
      //   console.log('in if co', createInvoiceFalg);
      //   swal("You can't create this invoice. Your invoice is already created!", "", "warning");
      //   return;
      // }
      
      
      let inputdata;

      if (invoiceType == "Monthly Maintenance") {
        const result = maintenenceList.concat(otherJsonList);

        if (result.length > 0) {
          result.map((option, index) => {
            mainteneceJson = { key: "", value: "" };
            mainteneceJson.key = option.maintenence_type;
            mainteneceJson.value = option.amount;
            if (option.maintenence_type != "" && option.amount != "") {
              maintenenceJsonList.push(mainteneceJson);
            }
          });
        }

        console.log("pppppp===>" + JSON.stringify(maintenenceJsonList));

        taxJsonList.map((option, index) => {
          mainteneceJson = { key: "", value: "", total: "" };
          mainteneceJson.key = option.key;
          mainteneceJson.value = option.value;
          mainteneceJson.total = option.total;

          // if(option.key!='' && option.value!="")
          //   {
          //     console.log(JSON.stringify(mainteneceJson));
          //     maintenenceJsonList.push(mainteneceJson);
          //   }
          maintenenceJsonList.push(mainteneceJson);
        });

        console.log("after tax===>" + JSON.stringify(maintenenceJsonList));
        let sum = taxJsonList
          .map((o) => o.total)
          .reduce((a, c) => {
            return a + c;
          });

        let newTotals = 0;
        if (isEditMonthlyInvoice) {
          let totHidden = hiddentotalPayable;
          newTotals = parseFloat(totHidden).toFixed(2);
          // newTotals = parseFloat(subTotal)+parseFloat(sum);
        } else {
          newTotals = parseFloat(subTotal) + parseFloat(sum);
        }
        console.log("first", maintenenceTotal);
        inputdata = {
          invoice_date: invoice_date,
          due_date: due_date,
          invoice_type: invoiceType,
          resident_id: selectedOwner,
          apartment_id: selectedApartment,
          subject: subject,
          maintenence_json_list: maintenenceJsonList,
          total_payment: parseFloat(newTotals),
          advance_received: parseFloat(advanceReceived),
          is_paid: false,
          past_due: past_due,
          late_fee: lateFee,
          // late_fee: 0, //change for late fee 0
          invoice_note: notes,
          maintenance_total: parseFloat(maintenenceTotal), // added new change by me
        };
      } else if (invoiceType == "Miscellaneous") {
        //handleChangeSave();

        const result = mischJsonList;
        console.log("my missss===>" + JSON.stringify(mischJsonList));

        if (result.length > 0) {
          result.map((option, index) => {
            mainteneceJson = {
              name: "",
              amount: "",
              duration_key: "",
              duration: "",
              total: "",
            };
            mainteneceJson.name = option.name;
            mainteneceJson.amount = option.amount;
            mainteneceJson.duration_key = option.duration_key;
            mainteneceJson.duration = option.duration;
            mainteneceJson.total = option.total;
            if (
              option.name != "" &&
              option.amount != "" &&
              option.duration_key != "" &&
              option.total != ""
            ) {
              maintenenceJsonList.push(mainteneceJson);
            }
          });
        }

        if (
          !mischJsonList[0].name ||
          !mischJsonList[0].amount ||
          !mischJsonList[0].duration_key ||
          !mischJsonList[0].duration ||
          !mischJsonList[0].total
        ) {
          swal("Please enter complete invoice details", "", "warning");
          return false;
        } else {
          for (var i = 0; i < taxJsonList.length; i++) {
            miscellaneousJson = {
              name: "",
              amount: "",
              duration: "",
              total: "",
            };

            miscellaneousJson.name = taxJsonList[i].key;
            miscellaneousJson.amount = taxJsonList[i].value;
            miscellaneousJson.duration = 0;
            miscellaneousJson.total = taxJsonList[i].total;
            if (taxJsonList[i].key != "" && taxJsonList[i].value != "") {
              maintenenceJsonList.push(miscellaneousJson);
            }
          }

          inputdata = {
            invoice_date: invoice_date,
            due_date: due_date,
            invoice_type: invoiceType,
            resident_id: selectedOwner,
            apartment_id: selectedApartment,
            subject: subject,
            //maintenence_json_list: mischJsonList,
            maintenence_json_list: maintenenceJsonList,
            total_payment: parseFloat(hiddenmisstotalPayable), //subTotal
            advance_received: parseFloat(advanceReceived),
            is_paid: false,
            past_due: past_due,
            late_fee: lateFee,
            invoice_note: notes,
            maintenance_total: parseFloat(maintenenceTotal), // added new change by me
          };
        }
      }

      if (isEditMonthlyInvoice) {
        setShowLoader(true);
        inputdata.invoice_id = props.name;
        await makePostRequest("invoice/update", inputdata)
          .then((response) => {
            if (response.data.data !== undefined) {
              swal("Success", "Invoice Updated Successully....", "success", {
                timer: 1000,
                buttons: false,
              });
              setShowLoader(false);
              navigate(
                "/MonthlyMaintenInvoicesPreview/" +
                  response.data.data.invoice_id
              );
            }
          })
          .catch((err) => {
            setShowLoader(false);
            swal("There was an error!", "more error details", "warning");
          });
      } else {
        if (invoiceType == "Miscellaneous" && mischJsonList.length < 1) {
          swal("Invalid Data", "Please Fill All Invoice Details", "warning", {
            timer: 3000,
            buttons: false,
          });
        } else {
          setShowLoader(true);
          await makePostRequest("invoice/insert", inputdata)
            .then((response) => {
              if (response.data.data !== undefined) {
                setCreateInvoiceFalg(null);
                // send notif

                // for notification to user added by me

               
                var jsonObj = { val: "New Invoice" };
                if (fcmToken) {
                  let bodyFormData = {
                    title: "New Invoice Received",
                    message: "New Invoice",
                    firebaseToken: fcmToken,
                  };

                  makePostRequest("guards/sendNotification", bodyFormData)
                    .then((responsenew) => {
                      // swal("Success", "Events created successfully", "success", {
                      //   timer: 1000,
                      //   buttons: false,
                      // });
                      // InvoiceListing();
                      swal("Success", "Invoice Created Successully....", "success", {
                        timer: 1000,
                        buttons: false,
                      });
                      setShowLoader(false);
                      if (invoiceType == "Monthly Maintenance")
                        navigate(
                          "/MonthlyMaintenInvoicesPreview/" +
                            response.data.data.invoice_id
                        );
                      else
                        navigate(
                          "/MiscellaneousInvoicesPreview/" +
                            response.data.data.invoice_id
                        );
                    })
                    .catch((err) => {
                      setShowLoader(false);
                      swal(
                        "There was an error in sending Notification!!",
                        "more error details",
                        "warning"
                      );
                    });
                } else {
                  // swal("Can not send notification,as FCM token not avaiable");
                  swal("Success", "Invoice Created Successully....", "success", {
                    timer: 1000,
                    buttons: false,
                  });
                 
                  setShowLoader(false);
                  if (invoiceType == "Monthly Maintenance")
                    navigate(
                      "/MonthlyMaintenInvoicesPreview/" +
                        response.data.data.invoice_id
                    );
                  else
                    navigate(
                      "/MiscellaneousInvoicesPreview/" +
                        response.data.data.invoice_id
                    );
                }

                // swal("Success", "Invoice Created Successully....", "success", {
                //   timer: 1000,
                //   buttons: false,
                // });

                // if (invoiceType == "Monthly Maintenance")
                //   navigate(
                //     "/MonthlyMaintenInvoicesPreview/" +
                //       response.data.data.invoice_id
                //   );
                // else
                //   navigate(
                //     "/MiscellaneousInvoicesPreview/" +
                //       response.data.data.invoice_id
                //   );
              }
            })
            .catch((err) => {
              setShowLoader(false);
              swal("There was an error!", "more error details", "warning");
            });
        }
      }
  //   } else {
  //     swal("You can't create this invoice. Your invoice is already created!", "", "warning");
  // }
    } else {
      swal("Please fill all details!", "", "warning");
    }
  }

  async function getMaxInvoiceId() {
    await makeGetRequest("invoice/getmaxid", "")
      .then((response) => {
        if (response.data.data !== undefined) {
          setInvoiceNo(response.data.data.rows[0].maxid + 1);
        }
      })
      .catch((err) => {
        swal("There was an error!", "more error details", "warning");
      });
  }

  // For Append
  const { useState } = React;
  let index = 0;
  const [count, setCount2] = useState(0);
  const { useState1 } = React;
  let index1 = 0;

  const AddedElement1 = () => (
    <div className="addedAppendLine" id="deleteId">
      <Grid container spacing={3}>
        <Grid item xs={12} md={8}>
          <input className="inputSt" placeholder="Maintenence Name" />
        </Grid>
        <Grid item xs={12} md={4}>
          <div className="inputWithICon">
            <CurrencyRupeeIcon />
            <input
              className="inputSt"
              placeholder="Amount"
              onBlur={(event) => getAddedMaintenence()}
            />
          </div>
        </Grid>

        <Button className="minusBtnNew">
          <RemoveIcon />
        </Button>
      </Grid>
    </div>
  );
  const [count1, setCount1] = useState(0);
  // End

  const addAminitiesClick = () => {
    if (invoiceType == "Miscellaneous") {
      handleChangeSave();
    } else {
    }
    var element = document.getElementById("addAminitiesId");
    element.classList.add("aminitiesMainAdd");
  };

  const [isEditMonthlyInvoice, setIsEditMonthlyInvoice] = useState(false);

  useEffect(() => {
    OwnerListing(q);
    setInvoiceType("Monthly Maintenance");

    if (props.name) {
      //TaxListing();
      EditMonthlyInvoice(props.name);
    } else {
      getMaxInvoiceId();
      var total = 0;

      setSubject(
        "Invoice for the month of " +
          moment(moment(invoice_date).utc().format("YYYY-MM-DD")).format("MMMM")
      );

      if (invoiceType == "Monthly Maintenance") {
        MaintenenceListing();
        TaxListing();
      }
    }
  }, [q]);
  const [upload, setUpload] = React.useState(false);

  async function EditMonthlyInvoice(invoiceId) {
    setIsEditMonthlyInvoice(true);

    setShowLoader(true);
    await makeGetRequest("invoice/getbyid/" + invoiceId)
      .then((response) => {
        if (response.status == "201") {
          console.log(response.data.data);
          var invoiceObj = response.data.data;

          console.log(
            "Edit API response==>" +
              JSON.stringify(invoiceObj.maintenence_json_list)
          );

          setInvoiceNo(invoiceObj.invoice_id);
          setSelectedOwner(invoiceObj.resident_id);
          handlechangeOwner(invoiceObj.resident_id);

          // setUpload(!upload);

          setSelectedApartment(invoiceObj.apartment_id);

          setApartmentNo(invoiceObj.uniq_apt_name);
          // setUpload(!upload);

          // handleeditchangeApartment(invoiceObj.apartment_id,invoiceObj.invoice_type);
          setInvoiceType(invoiceObj.invoice_type);
          setSubject(invoiceObj.subject);
          // setInvoiceDate(dayjs(invoiceObj.invoice_date).subtract(1, "day"));
          // setDueDate(dayjs(invoiceObj.due_date).subtract(1, "day"));
          setInvoiceDate(dayjs(invoiceObj.invoice_date));
          setDueDate(dayjs(invoiceObj.due_date));
          setSubTotal(invoiceObj.total_payment);

          setAdvanceReceived(invoiceObj.advance_received);
          let totadvance =
            parseFloat(invoiceObj.total_payment) -
            parseFloat(invoiceObj.advance_received);
          setTotalPayable(totadvance);
          setNotes(invoiceObj.invoice_note);
          setHiddenTotalPayable(
            parseFloat(invoiceObj.total_payment).toFixed(2)
          );

          let filteredUsers = invoiceObj.maintenence_json_list.filter(
            (user) => {
              if (user.total || user.total == 0) {
              } else {
                return user;
              }
            }
          );

          let filteredTaxes = invoiceObj.maintenence_json_list.filter(
            (taxesdata) => {
              if (taxesdata.total || taxesdata.total == 0) {
                if (taxesdata.key == "Late Fee") {
                  setLateFee(taxesdata.total);
                }

                return taxesdata;
              } else {
              }
            }
          );

          SetTaxJsonList(filteredTaxes);

          setMaintenenceJsonList(filteredUsers);

          console.log("json====>" + JSON.stringify(filteredUsers));
          let sum = filteredUsers
            .map((o) => o.value)
            .reduce((a, c) => {
              return parseFloat(a) + parseFloat(c);
            });
          setMaintenenceTotal(sum);
          // setTimeout(showcalqtyamt(invoiceObj.resident_id, invoiceObj.apartment_id,invoiceObj.invoice_type), 3000);
        } else {
          swal("There was an error!", response.message, "warning");
        }
        setShowLoader(false);
      })
      .catch((err) => {
        setShowLoader(false);
        console.log(err);
        swal("There was an error!", "more error details", "warning");
      });
  }

  let temp_subtotal = 0;

  async function removeMaintaince() {
    let tempindex = index;
    let countLength = maintenenceLength - 1;
    setMaintenenceLength(countLength);
    setCount1(index);
    let totamt = 0;
    let inputs = document.getElementsByTagName("input");
    let totamt_Array = [];
    let cnt_Array = 0;

    for (let i = 0; i < inputs.length; i++) {
      if (inputs.item(i).getAttribute("name") == "amount") {
        totamt_Array.push(inputs.item(i));
        cnt_Array++;
      }
    }

    for (let h = 0; h < cnt_Array; h++) {
      let priceval = parseFloat(totamt_Array[h].value);

      if (priceval) {
        if (priceval < 0) {
          totamt_Array[h].value = 0;
        } else {
          totamt = totamt + priceval;
        }
      } else {
        totamt_Array[h].value = 0;
      }
    }

    var txtsubtot = totamt.toFixed(2);
    document.getElementById("subTotal").innerHTML = txtsubtot;
    document.getElementById("totalPayable").value = txtsubtot;
    setSubTotal(txtsubtot);

    let adv = document.getElementById("advanceReceived").value;
    let newtot = 0;
    var txtPayTotal = document.getElementById("totalPayable").value;

    if (parseFloat(adv) <= parseFloat(txtPayTotal)) {
      newtot = parseFloat(txtPayTotal) - parseFloat(adv);
    } else {
      alert("Please enter valid amount");
      newtot = txtPayTotal;
    }

    let invoiceType = "Monthly Maintenance";
    TaxListing();
    if (invoiceType == "Monthly Maintenance") {
      SetTaxJsonList([]);
      while (taxJsonList.length > 0) {
        taxJsonList.pop();
      }

      var total = document.getElementById("subTotal").innerHTML;

      for (var i = 0; i < apartmentList.length; i++) {
        if (apartmentList[i].apartment_id == selectedApartment) {
          var apartmentObj = apartmentList[i];
          setApartmentNo(apartmentObj.uniq_apt_name);

          var tax = 0;
          var previousMonthTotPayable = 0;

          for (var k = 0; k < taxList.length; k++) {
            taxJson = { key: "", value: "", total: "" };

            var calculatedTax;
            if (taxList[k].tax_name === "Late Fee") {
              let latefeeAmt = taxList[k].tax_amount;
              let previousInvoice = "";
              setShowLoader(true);
              await makeGetRequest(
                "invoice/getpreviousmonth/" +
                  selectedOwner +
                  "/" +
                  selectedApartment,
                ""
              )
                .then((response) => {
                  if (response.status == "201") {
                    previousInvoice = response.data.data;
                  }
                })
                .catch((err) => {
                  swal("There was an error!", "more error details", "warning");
                  setShowLoader(false);
                });

              if (previousInvoice) {
                if (previousInvoice.is_paid) {
                  if (
                    new Date(previousInvoice.paid_date).getTime() >
                    new Date(previousInvoice.due_date).getTime()
                  ) {
                    var calculated_lateFee = (total * latefeeAmt) / 100;
                    taxList[k].calculatedTax = calculated_lateFee;
                    tax = tax + calculated_lateFee;
                    setLateFee(calculated_lateFee);
                  }
                } else {
                  let calculated_lateFee =
                    (total * taxList[k].tax_amount) / 100;
                  taxList[k].calculatedTax = calculated_lateFee;
                  tax = tax + calculated_lateFee;

                  previousMonthTotPayable = previousInvoice.total_payment;
                  setPastDue(previousMonthTotPayable);
                  setLateFee(calculated_lateFee);
                }
              } else taxList[k].calculatedTax = 0;
            } else {
              calculatedTax = (total * taxList[k].tax_amount) / 100;
              taxList[k].calculatedTax = calculatedTax;
              tax = tax + calculatedTax;
            }
            taxJson.key = taxList[k].tax_name;
            taxJson.value = taxList[k].tax_amount;
            taxJson.total = taxList[k].calculatedTax;
            taxJsonList.push(taxJson);
          }

          SetTaxJsonList(taxJsonList);
          setMaintenenceTotal(total);
          setTaxTotal(tax);
          setSubTotal(total);

          setTotalPayable(total - advanceReceived + tax);
          let tototal = parseFloat(total) + parseFloat(tax);
          setHiddenTotalPayable(parseFloat(tototal).toFixed(2));
          setShowLoader(false);
        }
      }
    }
  }

  async function removeEditMaintaince() {
    let tempindex = index;
    let countLength = maintenenceLength - 1;
    setMaintenenceLength(countLength);
    setCount1(index);
    let totamt = 0;
    let inputs = document.getElementsByTagName("input");
    let totamt_Array = [];
    let cnt_Array = 0;

    for (let i = 0; i < inputs.length; i++) {
      if (inputs.item(i).getAttribute("name") == "value") {
        totamt_Array.push(inputs.item(i));
        cnt_Array++;
      }

      if (inputs.item(i).getAttribute("name") == "amount") {
        totamt_Array.push(inputs.item(i));
        cnt_Array++;
      }
    }

    for (let h = 0; h < cnt_Array; h++) {
      let priceval = parseFloat(totamt_Array[h].value);

      if (priceval) {
        if (priceval < 0) {
          totamt_Array[h].value = 0;
        } else {
          totamt = totamt + priceval;
        }
      } else {
        totamt_Array[h].value = 0;
      }
    }

    var txtsubtot = totamt.toFixed(2);
    document.getElementById("subTotal").innerHTML = txtsubtot;
    document.getElementById("totalPayable").value = txtsubtot;
    setSubTotal(txtsubtot);

    let adv = document.getElementById("advanceReceived").value;
    let newtot = 0;
    var txtPayTotal = document.getElementById("totalPayable").value;

    if (parseFloat(adv) <= parseFloat(txtPayTotal)) {
      newtot = parseFloat(txtPayTotal) - parseFloat(adv);
    } else {
      alert("Please enter valid amount");
      newtot = txtPayTotal;
    }

    let invoiceType = "Monthly Maintenance";
    TaxListing();
    if (invoiceType == "Monthly Maintenance") {
      SetTaxJsonList([]);
      while (taxJsonList.length > 0) {
        taxJsonList.pop();
      }

      var total = document.getElementById("subTotal").innerHTML;

      for (var i = 0; i < apartmentList.length; i++) {
        if (apartmentList[i].apartment_id == selectedApartment) {
          var apartmentObj = apartmentList[i];
          setApartmentNo(apartmentObj.uniq_apt_name);

          var tax = 0;
          var previousMonthTotPayable = 0;

          for (var k = 0; k < taxList.length; k++) {
            taxJson = { key: "", value: "", total: "" };

            var calculatedTax;
            if (taxList[k].tax_name === "Late Fee") {
              let latefeeAmt = taxList[k].tax_amount;
              let previousInvoice = "";
              setShowLoader(true);
              await makeGetRequest(
                "invoice/getpreviousmonth/" +
                  selectedOwner +
                  "/" +
                  selectedApartment,
                ""
              )
                .then((response) => {
                  if (response.status == "201") {
                    previousInvoice = response.data.data;
                  }
                })
                .catch((err) => {
                  swal("There was an error!", "more error details", "warning");
                  setShowLoader(false);
                });

              if (previousInvoice) {
                if (previousInvoice.is_paid) {
                  if (
                    new Date(previousInvoice.paid_date).getTime() >
                    new Date(previousInvoice.due_date).getTime()
                  ) {
                    var calculated_lateFee = (total * latefeeAmt) / 100;
                    taxList[k].calculatedTax = calculated_lateFee;
                    tax = tax + calculated_lateFee;
                    setLateFee(calculated_lateFee);
                  }
                } else {
                  let calculated_lateFee =
                    (total * taxList[k].tax_amount) / 100;
                  taxList[k].calculatedTax = calculated_lateFee;
                  tax = tax + calculated_lateFee;

                  previousMonthTotPayable = previousInvoice.total_payment;
                  setPastDue(previousMonthTotPayable);
                  setLateFee(calculated_lateFee);
                }
              } else taxList[k].calculatedTax = 0;
            } else {
              calculatedTax = (total * taxList[k].tax_amount) / 100;
              taxList[k].calculatedTax = calculatedTax;
              tax = tax + calculatedTax;
            }
            taxJson.key = taxList[k].tax_name;
            taxJson.value = taxList[k].tax_amount;
            taxJson.total = taxList[k].calculatedTax;
            taxJsonList.push(taxJson);
          }

          SetTaxJsonList(taxJsonList);
          setMaintenenceTotal(total);
          setTaxTotal(tax);
          setSubTotal(total);

          setTotalPayable(total - advanceReceived + tax);
          let tototal = parseFloat(total) + parseFloat(tax);
          setHiddenTotalPayable(parseFloat(tototal).toFixed(2));
          setShowLoader(false);
        }
      }
    }
  }

  function removeEditMoreMaintaince(event, index) {
    setShowLoader(true);
    const list = [...otherJsonList];
    list.splice(index, 1);
    setOtherJsonList(list);
    setTimeout(removeEditMaintaince, 3000);
  }

  function removeMoreMaintaince(event, index) {
    setShowLoader(true);
    let countLength = maintenenceLength - 1;
    setMaintenenceLength(countLength);
    const list = [...otherJsonList];
    list.splice(index, 1);
    setOtherJsonList(list);
    setTimeout(removeMaintaince, 3000);
  }

  async function addMoreMaintaince(event, index) {
    let tempindex = index;
    let countLength = maintenenceLength + 1;
    setMaintenenceLength(countLength);
    var selectedApartment = document.getElementById("selectApartdrop").value;
    setSelectedApartment(selectedApartment);
    if (selectedApartment) {
      let data1 = [...otherJsonList];
      if (data1[tempindex].maintenence_type && data1[tempindex].amount) {
        setCount1(index);
        mainteneceJson = {
          maintenence_id: "",
          maintenence_type: "",
          amount: "",
          is_active: "",
          created_at: "",
          updated_at: "",
          is_deleted: "",
        };

        if (isEditMonthlyInvoice) maintenenceJsonList.push(mainteneceJson);
        else otherJsonList.push(mainteneceJson);

        let totamt = 0;
        let inputs = document.getElementsByTagName("input");
        let totamt_Array = [];
        let cnt_Array = 0;

        for (let i = 0; i < inputs.length; i++) {
          if (inputs.item(i).getAttribute("name") == "amount") {
            totamt_Array.push(inputs.item(i));
            cnt_Array++;
          }
        }

        for (let h = 0; h < cnt_Array; h++) {
          let priceval = parseFloat(totamt_Array[h].value);

          if (priceval) {
            if (priceval < 0) {
              totamt_Array[h].value = 0;
            } else {
              totamt = totamt + priceval;
            }
          } else {
            totamt_Array[h].value = 0;
          }
        }

        var txtsubtot = totamt.toFixed(2);
        document.getElementById("subTotal").innerHTML = txtsubtot;
        document.getElementById("totalPayable").value = txtsubtot;
        setSubTotal(txtsubtot);

        let adv = document.getElementById("advanceReceived").value;
        let newtot = 0;
        var txtPayTotal = document.getElementById("totalPayable").value;

        if (parseFloat(adv) <= parseFloat(txtPayTotal)) {
          newtot = parseFloat(txtPayTotal) - parseFloat(adv);
        } else {
          alert("Please enter valid amount");
          newtot = txtPayTotal;
        }

        let invoiceType = "Monthly Maintenance";

        TaxListing();
        if (invoiceType == "Monthly Maintenance") {
          SetTaxJsonList([]);
          while (taxJsonList.length > 0) {
            taxJsonList.pop();
          }

          var total = document.getElementById("subTotal").innerHTML;

          for (var i = 0; i < apartmentList.length; i++) {
            if (apartmentList[i].apartment_id == selectedApartment) {
              var apartmentObj = apartmentList[i];
              setApartmentNo(apartmentObj.uniq_apt_name);

              var tax = 0;
              var previousMonthTotPayable = 0;

              for (var k = 0; k < taxList.length; k++) {
                taxJson = { key: "", value: "", total: "" };

                var calculatedTax;
                if (taxList[k].tax_name === "Late Fee") {
                  let latefeeAmt = taxList[k].tax_amount;
                  let previousInvoice = "";
                  setShowLoader(true);
                  await makeGetRequest(
                    "invoice/getpreviousmonth/" +
                      selectedOwner +
                      "/" +
                      selectedApartment,
                    ""
                  )
                    .then((response) => {
                      if (response.status == "201") {
                        previousInvoice = response.data.data;
                      }
                    })
                    .catch((err) => {
                      swal(
                        "There was an error!",
                        "more error details",
                        "warning"
                      );
                      setShowLoader(false);
                    });

                  if (previousInvoice) {
                    if (previousInvoice.is_paid) {
                      if (
                        new Date(previousInvoice.paid_date).getTime() >
                        new Date(previousInvoice.due_date).getTime()
                      ) {
                        var calculated_lateFee = (total * latefeeAmt) / 100;
                        taxList[k].calculatedTax = calculated_lateFee;
                        tax = tax + calculated_lateFee;
                        setLateFee(calculated_lateFee);
                      }
                    } else {
                      let calculated_lateFee =
                        (total * taxList[k].tax_amount) / 100;
                      taxList[k].calculatedTax = calculated_lateFee;
                      tax = tax + calculated_lateFee;

                      previousMonthTotPayable = previousInvoice.total_payment;
                      setPastDue(previousMonthTotPayable);
                      setLateFee(calculated_lateFee);
                    }
                  } else taxList[k].calculatedTax = 0;
                } else {
                  calculatedTax = (total * taxList[k].tax_amount) / 100;
                  taxList[k].calculatedTax = calculatedTax;
                  tax = tax + calculatedTax;
                }
                taxJson.key = taxList[k].tax_name;
                taxJson.value = taxList[k].tax_amount;
                taxJson.total = taxList[k].calculatedTax;
                taxJsonList.push(taxJson);
              }

              SetTaxJsonList(taxJsonList);
              setMaintenenceTotal(total);
              setTaxTotal(tax);
              setSubTotal(total);

              setTotalPayable(total - advanceReceived + tax);
              let tototal = parseFloat(total) + parseFloat(tax);
              setHiddenTotalPayable(parseFloat(tototal).toFixed(2));
              setShowLoader(false);
            }
          }
        }
      } else {
        swal("Other Maintenance Details should not be blank", "", "warning");
      }
    } else {
      swal("Warning", "First select owner and apartment details !", "warning");
    }
  }

  async function addEditMaintaince(event, index) {
    let tempindex = index;
    // let countLength = maintenenceLength + 1;
    // setMaintenenceLength(countLength);
    var selectedApartment = document.getElementById("selectApartdrop").value;
    setSelectedApartment(selectedApartment);
    if (selectedApartment) {
      let data1 = [...otherJsonList];
      if (data1[tempindex].maintenence_type && data1[tempindex].amount) {
        setCount1(index);
        mainteneceJson = {
          maintenence_id: "",
          maintenence_type: "",
          amount: "",
          is_active: "",
          created_at: "",
          updated_at: "",
          is_deleted: "",
        };
        otherJsonList.push(mainteneceJson);

        let totamt = 0;
        let inputs = document.getElementsByTagName("input");
        let totamt_Array = [];
        let cnt_Array = 0;

        for (let i = 0; i < inputs.length; i++) {
          if (inputs.item(i).getAttribute("name") == "value") {
            totamt_Array.push(inputs.item(i));
            cnt_Array++;
          }

          if (inputs.item(i).getAttribute("name") == "amount") {
            totamt_Array.push(inputs.item(i));
            cnt_Array++;
          }
        }

        for (let h = 0; h < cnt_Array; h++) {
          let priceval = parseFloat(totamt_Array[h].value);

          if (priceval) {
            if (priceval < 0) {
              totamt_Array[h].value = 0;
            } else {
              totamt = totamt + priceval;
            }
          } else {
            totamt_Array[h].value = 0;
          }
        }

        var txtsubtot = totamt.toFixed(2);
        document.getElementById("subTotal").innerHTML = txtsubtot;
        document.getElementById("totalPayable").value = txtsubtot;
        setSubTotal(txtsubtot);

        let adv = document.getElementById("advanceReceived").value;
        let newtot = 0;
        var txtPayTotal = document.getElementById("totalPayable").value;

        if (parseFloat(adv) <= parseFloat(txtPayTotal)) {
          newtot = parseFloat(txtPayTotal) - parseFloat(adv);
        } else {
          alert("Please enter valid amount");
          newtot = txtPayTotal;
        }

        let invoiceType = "Monthly Maintenance";

        TaxListing();
        if (invoiceType == "Monthly Maintenance") {
          SetTaxJsonList([]);
          while (taxJsonList.length > 0) {
            taxJsonList.pop();
          }

          var total = document.getElementById("subTotal").innerHTML;

          for (var i = 0; i < apartmentList.length; i++) {
            if (apartmentList[i].apartment_id == selectedApartment) {
              var apartmentObj = apartmentList[i];
              setApartmentNo(apartmentObj.uniq_apt_name);

              var tax = 0;
              var previousMonthTotPayable = 0;

              for (var k = 0; k < taxList.length; k++) {
                taxJson = { key: "", value: "", total: "" };

                var calculatedTax;
                if (taxList[k].tax_name === "Late Fee") {
                  let latefeeAmt = taxList[k].tax_amount;
                  let previousInvoice = "";
                  setShowLoader(true);
                  await makeGetRequest(
                    "invoice/getpreviousmonth/" +
                      selectedOwner +
                      "/" +
                      selectedApartment,
                    ""
                  )
                    .then((response) => {
                      if (response.status == "201") {
                        previousInvoice = response.data.data;
                      }
                    })
                    .catch((err) => {
                      swal(
                        "There was an error!",
                        "more error details",
                        "warning"
                      );
                      setShowLoader(false);
                    });

                  if (previousInvoice) {
                    if (previousInvoice.is_paid) {
                      if (
                        new Date(previousInvoice.paid_date).getTime() >
                        new Date(previousInvoice.due_date).getTime()
                      ) {
                        var calculated_lateFee = (total * latefeeAmt) / 100;
                        taxList[k].calculatedTax = calculated_lateFee;
                        tax = tax + calculated_lateFee;
                        setLateFee(calculated_lateFee);
                      }
                    } else {
                      let calculated_lateFee =
                        (total * taxList[k].tax_amount) / 100;
                      taxList[k].calculatedTax = calculated_lateFee;
                      tax = tax + calculated_lateFee;

                      previousMonthTotPayable = previousInvoice.total_payment;
                      setPastDue(previousMonthTotPayable);
                      setLateFee(calculated_lateFee);
                    }
                  } else taxList[k].calculatedTax = 0;
                } else {
                  calculatedTax = (total * taxList[k].tax_amount) / 100;
                  taxList[k].calculatedTax = calculatedTax;
                  tax = tax + calculatedTax;
                }
                taxJson.key = taxList[k].tax_name;
                taxJson.value = taxList[k].tax_amount;
                taxJson.total = taxList[k].calculatedTax;
                taxJsonList.push(taxJson);
              }

              SetTaxJsonList(taxJsonList);
              setMaintenenceTotal(total);
              setTaxTotal(tax);
              setSubTotal(total);

              setTotalPayable(total - advanceReceived + tax);
              let tototal = parseFloat(total) + parseFloat(tax);
              setHiddenTotalPayable(parseFloat(tototal).toFixed(2));
              setShowLoader(false);
            }
          }
        }
      } else {
        swal("Other Maintenance Details should not be blank", "", "warning");
      }
    } else {
      swal("Warning", "First select owner and apartment details !", "warning");
    }
  }

  let miscellaneousJson;
  const [miscellaneousTaxTotal, setMiscellaneousTaxTotal] = React.useState(0);

  // Function to get last added miscllenious input fields without clicking plus icon
  async function handleChangeSave(index) {
    if (selectedApartment) {
      if (
        document.getElementById("misch_name").value &&
        document.getElementById("misch_amt").value &&
        document.getElementById("misch_duration").value &&
        document.getElementById("misch_duration_key").value
      ) {
        setCount2(index);
        miscellaneousJson = {
          name: "",
          amount: "",
          duration_key: "",
          duration: "",
          total: "",
        };

        miscellaneousJson.name = document.getElementById("misch_name").value;
        miscellaneousJson.amount = document.getElementById("misch_amt").value;
        miscellaneousJson.duration_key =
          document.getElementById("misch_duration_key").value;
        miscellaneousJson.duration =
          document.getElementById("misch_duration").value;
        let total =
          parseInt(document.getElementById("misch_amt").value) *
          parseInt(document.getElementById("misch_duration").value);
        document.getElementById("misch_total").value = total;
        miscellaneousJson.total = total;
        mischJsonList.push(miscellaneousJson);

        document.getElementById("misch_name").value = "";
        document.getElementById("misch_amt").value = "";
        document.getElementById("misch_duration").value = "";
        document.getElementById("misch_duration_key").value = "";
        document.getElementById("misch_total").value = 0;
      } else {
        if (mischJsonList.length < 1)
          swal(
            "Please Fill All Invoice Details !",
            "more error details",
            "warning"
          );
      }
    } else {
      swal("First select owner !", "more error details", "warning");
      return false;
    }
  }

  //=================================================================================

  const handleMissMaintenencevalue = (event, index) => {
    let data1 = [...mischJsonList];
    data1[index].name = event.target.value;
    setMischJsonList(data1);
  };

  const handleMissvalueChange = (event, index) => {
    let data = [...mischJsonList];
    data[index].amount = event.target.value
      .replace(/[^0-9.]/g, "")
      .replace(/(\..*?)\..*/g, "$1")
      .replace(/(\.\d{2}).+/g, "$1");
    let durkeyamount = 0;
    let durtimeamount = 0;
    if (data[index].amount != "" && data[index].amount > 0) {
      durkeyamount = parseFloat(data[index].amount);
    }

    if (data[index].duration != "" && data[index].duration > 0) {
      durtimeamount = parseFloat(data[index].duration);
    }
    //setShowLoader(true);
    let durtotal = durkeyamount * durtimeamount;
    let durationTotal = durtotal.toFixed(2);
    data[index].total = durationTotal;
    setMischJsonList(data);
  };

  const handleMissDurationKey = (event, index) => {
    let data1 = [...mischJsonList];
    data1[index].duration_key = event.target.value;
    setMischJsonList(data1);
  };

  const handleMissDuration = (event, index) => {
    let data = [...mischJsonList];
    if (data[index].duration_key == "") {
      swal(
        "Invalid Data",
        "Please select duration and duration amount",
        "warning",
        {
          timer: 3000,
          buttons: false,
        }
      );
    } else {
      data[index].duration = event.target.value
        .replace(/[^0-9.]/g, "")
        .replace(/(\..*?)\..*/g, "$1")
        .replace(/(\.\d{2}).+/g, "$1");
      console.log("dddddd" + JSON.stringify(data));
      let durkeyamount = 0;
      let durtimeamount = 0;
      if (data[index].amount != "" && data[index].amount > 0) {
        durkeyamount = parseFloat(data[index].amount);
      }

      if (data[index].duration != "" && data[index].duration > 0) {
        durtimeamount = parseFloat(data[index].duration);
      }
      //setShowLoader(true);
      let durtotal = durkeyamount * durtimeamount;
      let durationTotal = durtotal.toFixed(2);
      data[index].total = durationTotal;
      setMischJsonList(data);
      // setTimeout(calmisstax(), 1000);
    }
  };

  function removeMissMaintaince(event, index) {
    setShowLoader(true);
    const list = [...mischJsonList];
    list.splice(index, 1);
    setMischJsonList(list);
    setTimeout(deleteMissMaintaince, 3000);
  }

  async function deleteMissMaintaince() {
    let totamt = 0;
    let inputs = document.getElementsByTagName("input");
    let totamt_Array = [];
    let cnt_Array = 0;

    for (let i = 0; i < inputs.length; i++) {
      if (inputs.item(i).getAttribute("name") === "total") {
        totamt_Array.push(inputs.item(i));
        cnt_Array++;
      }
    }

    for (let h = 0; h < cnt_Array; h++) {
      let priceval = parseFloat(totamt_Array[h].value);

      if (priceval) {
        if (priceval < 0) {
          totamt_Array[h].value = 0;
        } else {
          totamt = totamt + priceval;
        }
      } else {
        totamt_Array[h].value = 0;
      }
    }

    var txtsubtot = totamt.toFixed(2);
    document.getElementById("subTotal").innerHTML = txtsubtot;

    TaxListing();
    SetTaxJsonList([]);
    while (taxJsonList.length > 0) {
      taxJsonList.pop();
    }

    var total = document.getElementById("subTotal").innerHTML;
    for (var i = 0; i < apartmentList.length; i++) {
      if (apartmentList[i].apartment_id == selectedApartment) {
        var apartmentObj = apartmentList[i];
        setApartmentNo(apartmentObj.uniq_apt_name);

        var tax = 0;
        var previousMonthTotPayable = 0;
        for (var k = 0; k < taxList.length; k++) {
          taxJson = { key: "", value: "", total: "" };

          var calculatedTax;

          if (taxList[k].tax_name === "Late Fee") {
            let latefeeAmt = taxList[k].tax_amount;
            let previousInvoice = "";

            await makeGetRequest(
              "invoice/getpreviousmonth/" +
                selectedOwner +
                "/" +
                selectedApartment,
              ""
            )
              .then((response) => {
                if (response.status == "201") {
                  previousInvoice = response.data.data;
                }
              })
              .catch((err) => {
                swal("There was an error!", "more error details", "warning");
              });

            if (previousInvoice) {
              if (previousInvoice.is_paid) {
                if (
                  new Date(previousInvoice.paid_date).getTime() >
                  new Date(previousInvoice.due_date).getTime()
                ) {
                  var calculated_lateFee = (total * latefeeAmt) / 100;
                  taxList[k].calculatedTax = calculated_lateFee;
                  tax = tax + calculated_lateFee;
                  setLateFee(calculated_lateFee);
                }
              } else {
                let calculated_lateFee = (total * taxList[k].tax_amount) / 100;
                taxList[k].calculatedTax = calculated_lateFee;
                tax = tax + calculated_lateFee;

                previousMonthTotPayable = previousInvoice.total_payment;
                setPastDue(previousMonthTotPayable);
                setLateFee(calculated_lateFee);
              }
            } else taxList[k].calculatedTax = 0;
          } else {
            calculatedTax = (total * taxList[k].tax_amount) / 100;

            taxList[k].calculatedTax = calculatedTax;
            tax = tax + calculatedTax;
          }
          taxJson.key = taxList[k].tax_name;
          taxJson.value = taxList[k].tax_amount;
          taxJson.total = taxList[k].calculatedTax;
          taxJsonList.push(taxJson);
        }

        setShowLoader(false);

        SetTaxJsonList(taxJsonList);
        //setMaintenenceTotal(total);
        setTaxTotal(tax);
        setSubTotal(total);

        let taxwithtotal = parseFloat(total) + parseFloat(tax);
        if (parseFloat(advanceReceived) <= parseFloat(taxwithtotal)) {
          let actualtotal =
            parseFloat(taxwithtotal) - parseFloat(advanceReceived);
          setTotalPayable(actualtotal);
        } else {
          setTotalPayable(taxwithtotal);
          setAdvanceReceived(0);
        }

        let tototal = parseFloat(total) + parseFloat(tax);
        setHiddenMissTotalPayable(parseFloat(tototal).toFixed(2));
      }
    }
  }

  async function calMissCharges(event, index) {
    let totamt = 0;
    let inputs = document.getElementsByTagName("input");
    let totamt_Array = [];
    let cnt_Array = 0;

    for (let i = 0; i < inputs.length; i++) {
      if (inputs.item(i).getAttribute("name") === "total") {
        totamt_Array.push(inputs.item(i));
        cnt_Array++;
      }
    }

    for (let h = 0; h < cnt_Array; h++) {
      let priceval = parseFloat(totamt_Array[h].value);

      if (priceval) {
        if (priceval < 0) {
          totamt_Array[h].value = 0;
        } else {
          totamt = totamt + priceval;
        }
      } else {
        totamt_Array[h].value = 0;
      }
    }

    var txtsubtot = totamt.toFixed(2);
    document.getElementById("subTotal").innerHTML = txtsubtot;

    TaxListing();
    SetTaxJsonList([]);
    while (taxJsonList.length > 0) {
      taxJsonList.pop();
    }

    var total = document.getElementById("subTotal").innerHTML;
    for (var i = 0; i < apartmentList.length; i++) {
      if (apartmentList[i].apartment_id == selectedApartment) {
        var apartmentObj = apartmentList[i];
        setApartmentNo(apartmentObj.uniq_apt_name);

        var tax = 0;
        var previousMonthTotPayable = 0;
        for (var k = 0; k < taxList.length; k++) {
          taxJson = { key: "", value: "", total: "" };

          var calculatedTax;

          if (taxList[k].tax_name === "Late Fee") {
            let latefeeAmt = taxList[k].tax_amount;
            let previousInvoice = "";

            await makeGetRequest(
              "invoice/getpreviousmonth/" +
                selectedOwner +
                "/" +
                selectedApartment,
              ""
            )
              .then((response) => {
                if (response.status == "201") {
                  previousInvoice = response.data.data;
                }
              })
              .catch((err) => {
                swal("There was an error!", "more error details", "warning");
              });

            if (previousInvoice) {
              if (previousInvoice.is_paid) {
                if (
                  new Date(previousInvoice.paid_date).getTime() >
                  new Date(previousInvoice.due_date).getTime()
                ) {
                  var calculated_lateFee = (total * latefeeAmt) / 100;
                  taxList[k].calculatedTax = calculated_lateFee;
                  tax = tax + calculated_lateFee;
                  setLateFee(calculated_lateFee);
                }
              } else {
                let calculated_lateFee = (total * taxList[k].tax_amount) / 100;
                taxList[k].calculatedTax = calculated_lateFee;
                tax = tax + calculated_lateFee;

                previousMonthTotPayable = previousInvoice.total_payment;
                setPastDue(previousMonthTotPayable);
                setLateFee(calculated_lateFee);
              }
            } else taxList[k].calculatedTax = 0;
          } else {
            calculatedTax = (total * taxList[k].tax_amount) / 100;

            taxList[k].calculatedTax = calculatedTax;
            tax = tax + calculatedTax;
          }
          taxJson.key = taxList[k].tax_name;
          taxJson.value = taxList[k].tax_amount;
          taxJson.total = taxList[k].calculatedTax;
          taxJsonList.push(taxJson);
        }

        setShowLoader(false);

        SetTaxJsonList(taxJsonList);

        setTaxTotal(tax);
        setSubTotal(total);

        let taxwithtotal = parseFloat(total) + parseFloat(tax);
        if (parseFloat(advanceReceived) <= parseFloat(taxwithtotal)) {
          let actualtotal =
            parseFloat(taxwithtotal) - parseFloat(advanceReceived);
          setTotalPayable(actualtotal);
        } else {
          setTotalPayable(taxwithtotal);
          setAdvanceReceived(0);
        }

        let tototal = parseFloat(total) + parseFloat(tax);

        setHiddenMissTotalPayable(parseFloat(tototal).toFixed(2));
      }
    }

    setMaintenenceTotal(total);
  }

  async function handleChangeMiscellaneous(event, index) {
    var selectedApartment = document.getElementById(
      "selectmissApartdrop"
    ).value;
    if (selectedApartment) {
      setSelectedApartment(selectedApartment);
      let data1 = [...mischJsonList];
      setShowLoader(true);
      if (
        data1[index].name &&
        data1[index].amount &&
        data1[index].duration_key &&
        data1[index].duration &&
        data1[index].total
      ) {
        miscellaneousJson = {
          name: "",
          amount: "",
          duration_key: "",
          duration: "",
          total: "",
        };
        mischJsonList.push(miscellaneousJson);
        setMischJsonList(mischJsonList);

        setTimeout(function () {
          setShowLoader(false);
        }, 3000);
      } else {
        swal("Please enter complete invoice details", "", "warning");
        setShowLoader(false);
      }
    } else {
      swal("Warning", "First select owner and apartment details !", "warning");
      setShowLoader(false);
    }
  }

  //=================================================================================

  const [count3, setCount3] = useState(0);

  async function handleChangeAmenityJson(index) {
    if (selectedApartment) {
      if (
        document.getElementById("selectedAmenity").value &&
        document.getElementById("amenity_duration").value
      ) {
        setCount3(index);

        miscellaneousJson = { name: "", amount: "", duration: "", total: "" };
        miscellaneousJson.name = selectedAmenityName;
        miscellaneousJson.amount = amount;
        miscellaneousJson.duration =
          document.getElementById("amenity_duration").value;
        miscellaneousJson.total =
          document.getElementById("AmenityTotalAmt").value;

        mischJsonList.push(miscellaneousJson);
        amenitiesJsonList.push(miscellaneousJson);

        document.getElementById("selectedAmenity").value = "";
        document.getElementById("amenityAmt").value = 0;
        document.getElementById("amenity_duration").value = 0;
        document.getElementById("AmenityTotalAmt").value = 0;
      } else {
        swal("First Fill Data !", "more error details", "warning");
      }
    } else {
      swal("First select owner !", "more error details", "warning");
    }
  }


  async function checkuniqueinvoice(invoiceDate, apartmentId, residentId) {
    let bodyFormData = {
      resident_id: residentid,
      apartment_id: selectedApartment,
      current_date: invoice_date,
      invoice_type: invoiceType
    };
    setShowLoader(true);
    await makePostRequest("invoice/getinvoicemonth", bodyFormData)
      .then((response) => {
        if (response.status == "201") {
          const data = response.data.data;

          if (data.length === 0) {
           setCreateInvoiceFalg(true)
           console.log("if",createInvoiceFalg)
          } else {
            console.log("els")
            setCreateInvoiceFalg(false)
            swal("You can't create this invoice. Your invoice is already created!", "", "warning");
          }

        } else {
          swal("There was an error!", response.message, "warning");
        }
        setShowLoader(false);
      })
      .catch((err) => {
        setShowLoader(false);
        swal("There was an error!", "more error details", "warning");
      });
  }

  useEffect(() => {
    if (residentid > 0 && selectedApartment >0 && !isEditMonthlyInvoice && invoiceType==="Monthly Maintenance") {
      checkuniqueinvoice();
    }
  }, [residentid,selectedApartment]);

  return (
    <>
      <div className="createInvoiceNewMain">
        <div className="invoicePaidUnpaidTabMain">
          <Box sx={{ width: "100%" }}>
            {!isEditMonthlyInvoice ? (
              <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                <Tabs
                  value={value}
                  onChange={handleChange}
                  aria-label="basic tabs example"
                  variant="scrollable"
                  scrollButtons
                  allowScrollButtonsMobile
                >
                  <Tab
                    label="Monthly Maintenance Invoices"
                    {...a11yProps(0)}
                    onClick={() => handleChangeTabs("Monthly Maintenance")}
                  />

                  <Tab
                    label="Miscellaneous Invoices"
                    {...a11yProps(1)}
                    onClick={() => handleChangeTabs("Miscellaneous")}
                  />
                </Tabs>
              </Box>
            ) : (
              <></>
            )}

            <TabPanel value={value} index={0}>
              <div>
                <Formik
                  enableReinitialize
                  initialValues={formikInitials}
                  validationSchema={Validation_Schema}
                  onSubmit={saveInvoice}
                >
                  {({
                    values,
                    handleChange,
                    errors,
                    setFieldTouched,
                    touched,
                    isValid,
                    handleSubmit,
                  }) => (
                    <Form>
                      <div className="invoiceMain">
                        <div className="invoiceInnerMain">
                          <Grid container spacing={3}>
                            {/* <Grid item xs={12} md={12}>
                            <h1 className="panelHeading">Edit Monthly Invoice</h1>
                            </Grid> */}

                            <Grid item xs={12} md={4}>
                              <input
                                className="inputSt"
                                placeholder="Search by Name"
                                onChangeCapture={(e) => setQ(e.target.value)}
                              />
                            </Grid>
                            <Grid item xs={12} md={4}>
                              <select
                                className="inputSt"
                                value={selectedOwner}
                                onChange={(e) =>
                                  handlechangeOwner(e.target.value)
                                }
                                onBlur={() => setFieldTouched("selectedOwner")}
                              >
                                <option value="">Select Owner</option>
                                {ownersList.map((option) => (
                                  <option
                                    key={option.resident_id}
                                    value={option.resident_id}
                                    data-isd={
                                      option.user_obj.first_name +
                                      " " +
                                      option.user_obj.last_name
                                    }
                                  >
                                    {option.user_obj.first_name +
                                      " " +
                                      option.user_obj.last_name}
                                  </option>
                                ))}
                              </select>
                              {errors.selectedOwner && touched.selectedOwner ? (
                                <div
                                  style={{ color: "red" }}
                                  className="errorField"
                                >
                                  {errors.selectedOwner}
                                </div>
                              ) : null}
                            </Grid>
                            <Grid item xs={12} md={4}>
                              <select
                                className="inputSt"
                                name="selectApartdrop"
                                id="selectApartdrop"
                                value={selectedApartment}
                                onChange={(e) =>
                                  handlechangeApartment(
                                    e.target.value,
                                    "Monthly Maintenance"
                                  )
                                }
                              >
                                <option value="">Select Apartment</option>
                                {apartmentList.map((option) => (
                                  <option
                                    key={option.apartment_id}
                                    value={option.apartment_id}
                                    data-isd={option.uniq_apt_name}
                                  >
                                    {option.uniq_apt_name}
                                  </option>
                                ))}
                              </select>
                            </Grid>
                          </Grid>
                          {showEmailToTenantMessage ? (
                            <Grid container>
                              <Grid item xs={12} md={12}>
                                <span>
                                  This Apartment is Tenant Occupied Do you want
                                  to send Invoice Email to Tenant Also.
                                </span>
                              </Grid>
                            </Grid>
                          ) : (
                            <></>
                          )}
                          <Grid container>
                            <Grid item xs={12} md={12}>
                              <h2 className="invoiceSubHeading">
                                Create Invoice
                              </h2>
                            </Grid>
                          </Grid>
                          <Grid container spacing={3}>
                            <Grid item xs={12} md={4}>
                              <label className="tabsLabel">Invoice #</label>
                              <input
                                className="inputSt"
                                placeholder="267345"
                                value={invoiceNo}
                              />
                            </Grid>
                            <Grid item xs={12} md={4}>
                              <label className="tabsLabel">Invoice Date</label>
                              <div className="dateTimeMain">
                                <LocalizationProvider
                                  dateAdapter={AdapterDayjs}
                                >
                                  <Stack className="inputSt">
                                    <DesktopDatePicker
                                      inputFormat="MM/DD/YYYY"
                                      value={invoice_date}
                                      onChange={handleInvoiceDate}
                                      renderInput={(params) => (
                                        <TextField {...params} />
                                      )}
                                    />
                                  </Stack>
                                </LocalizationProvider>
                              </div>
                            </Grid>
                            <Grid item xs={12} md={4}>
                              <label className="tabsLabel">Due Date</label>
                              <div className="dateTimeMain">
                                <LocalizationProvider
                                  dateAdapter={AdapterDayjs}
                                >
                                  <Stack className="inputSt">
                                    <DesktopDatePicker
                                      inputFormat="MM/DD/YYYY"
                                      value={due_date}
                                      onChange={handleDueDate}
                                      renderInput={(params) => (
                                        <TextField {...params} />
                                      )}
                                    />
                                  </Stack>
                                </LocalizationProvider>
                              </div>
                            </Grid>
                            <Grid item xs={12} md={12}>
                              <input
                                className="inputSt"
                                placeholder="Subject"
                                value={values.subject}
                                onChange={handleChange("subject")}
                                onBlur={() => setFieldTouched("subject")}
                                onChangeCapture={(e) =>
                                  setSubject(e.target.value)
                                }
                              />
                              {errors.subject && touched.subject ? (
                                <div
                                  style={{ color: "red" }}
                                  className="errorField"
                                >
                                  {errors.subject}
                                </div>
                              ) : null}
                              <Grid item xs={12} md={12}></Grid>
                            </Grid>
                          </Grid>

                          <Grid container>
                            <Grid item xs={12} md={12}>
                              <h2 className="invoiceSubHeading">Bill to</h2>
                            </Grid>
                          </Grid>

                          <Grid container spacing={3}>
                            <Grid item xs={12} md={4}>
                              <input
                                type="text"
                                className="inputSt"
                                placeholder="Jarome Bell"
                                disabled
                                value={billto}
                              />
                            </Grid>
                            <Grid item xs={12} md={4}>
                              <input
                                className="inputSt"
                                placeholder="WIng-B"
                                disabled
                                value={apartmentNo.split("/")[1]}
                              />
                            </Grid>
                            <Grid item xs={12} md={4}>
                              <input
                                className="inputSt"
                                placeholder="Flat No. 204"
                                disabled
                                value={apartmentNo}
                              />
                            </Grid>
                            <Grid item xs={12} md={4}>
                              <div className="inputWithICon">
                                <LocalPhoneIcon />
                                <input
                                  className="inputSt"
                                  placeholder="9823898485"
                                  disabled
                                  value={contactNo}
                                />
                              </div>
                            </Grid>
                            <Grid item xs={12} md={4}>
                              <div className="inputWithICon">
                                <MailOutlineIcon />
                                <input
                                  className="inputSt"
                                  placeholder="sample@gmail.com"
                                  disabled
                                  value={emailId}
                                />
                              </div>
                            </Grid>
                          </Grid>

                          <Grid container>
                            <Grid item xs={12} md={12}>
                              <h2 className="invoiceSubHeading">
                                Maintenance Details
                              </h2>
                            </Grid>
                          </Grid>

                          {isEditMonthlyInvoice ? (
                            <>
                              {maintenenceJsonList.map((option, index) => (
                                <>
                                  {option.total || option.total == 0 ? (
                                    <></>
                                  ) : (
                                    <>
                                      <Grid
                                        container
                                        spacing={3}
                                        className="botSpfild"
                                      >
                                        <Grid item xs={12} md={9}>
                                          <input
                                            className="inputSt"
                                            value={option.key}
                                            name="key"
                                            onChange={(event) =>
                                              handleEditMaintenencevalue(
                                                event,
                                                index
                                              )
                                            }
                                          />
                                        </Grid>
                                        <Grid item xs={12} md={3}>
                                          <div className="inputWithICon">
                                            <CurrencyRupeeIcon />
                                            <input
                                              className="inputSt"
                                              name="amount"
                                              value={option.value}
                                              maxLength={8}
                                              onChange={(event) =>
                                                handleEditUservalueChange(
                                                  event,
                                                  index
                                                )
                                              }
                                              onBlur={(event) =>
                                                numberEditfloat(event, index)
                                              }
                                              onKeyUp={(event) =>
                                                calEditamt(event, index)
                                              }
                                            />
                                          </div>
                                        </Grid>
                                      </Grid>
                                    </>
                                  )}
                                </>
                              ))}
                            </>
                          ) : (
                            <>
                              {maintenenceList.map((option, index) => (
                                <Grid
                                  container
                                  spacing={3}
                                  className="botSpfild"
                                  key={index}
                                >
                                  <Grid item xs={12} md={9}>
                                    <input
                                      className="inputSt"
                                      name="maintenence_type"
                                      value={option.maintenence_type}
                                      onChange={(event) =>
                                        handleMaintenencevalue(event, index)
                                      }
                                    />
                                  </Grid>
                                  <Grid item xs={12} md={3}>
                                    <div className="inputWithICon">
                                      <CurrencyRupeeIcon />
                                      <input
                                        className="inputSt"
                                        name="amount"
                                        value={option.amount}
                                        maxLength={8}
                                        onChange={(event) =>
                                          handleUservalueChange(event, index)
                                        }
                                        onBlur={(event) =>
                                          numberfloat(event, index)
                                        }
                                        onKeyUp={(event) =>
                                          calqtyamt(event, index)
                                        }
                                      />
                                    </div>
                                  </Grid>
                                </Grid>
                              ))}
                            </>
                          )}
                          <div className="addAminitiesMain" id="addAminitiesId">
                            <Grid container>
                              <Grid item xs={12} md={12}>
                                <Button
                                  className="addAminitiesBt"
                                  onClick={addAminitiesClick}
                                >
                                  <AddIcon /> Other
                                </Button>
                              </Grid>
                              <Grid item xs={12} md={12}>
                                <div className="showingAminities">
                                  <Grid container>
                                    <Grid item xs={12} md={12}>
                                      <h2 className="invoiceSubHeading">
                                        Other Maintenance Details
                                      </h2>
                                    </Grid>
                                  </Grid>

                                  {otherJsonList.map((option, index) => (
                                    <div
                                      className="addedAppendLine"
                                      id="deleteId"
                                    >
                                      <Grid container spacing={3}>
                                        <Grid item xs={12} md={8}>
                                          <input
                                            className="inputSt"
                                            placeholder="Maintenence Name"
                                            name="maintenence_type"
                                            value={option.maintenence_type}
                                            onChange={(event) =>
                                              handleOtherMaintenencevalue(
                                                event,
                                                index
                                              )
                                            }
                                          />
                                        </Grid>
                                        <Grid item xs={12} md={4}>
                                          <div className="inputWithICon">
                                            <CurrencyRupeeIcon />
                                            <input
                                              className="inputSt"
                                              placeholder="Amount"
                                              name="amount"
                                              value={option.amount}
                                              onChange={(event) =>
                                                handleOthervalueChange(
                                                  event,
                                                  index
                                                )
                                              }
                                              maxLength={8}
                                              onBlur={(event) =>
                                                numbertofloat(event, index)
                                              }
                                              onKeyUp={(event) =>
                                                newcheck(
                                                  event,
                                                  maintenenceLength + 1,
                                                  isEditMonthlyInvoice
                                                )
                                              }
                                            />
                                          </div>
                                        </Grid>

                                        {otherJsonList.length > 1 &&
                                        otherJsonList.length - 1 != index ? (
                                          isEditMonthlyInvoice ? (
                                            <Button
                                              className="minusBtnNew"
                                              onClick={(event) =>
                                                removeEditMoreMaintaince(
                                                  event,
                                                  index
                                                )
                                              }
                                            >
                                              <RemoveIcon />
                                            </Button>
                                          ) : (
                                            <Button
                                              className="minusBtnNew"
                                              onClick={(event) =>
                                                removeMoreMaintaince(
                                                  event,
                                                  index
                                                )
                                              }
                                            >
                                              <RemoveIcon />
                                            </Button>
                                          )
                                        ) : null}

                                        {otherJsonList.length - 1 === index ? (
                                          isEditMonthlyInvoice ? (
                                            <Button
                                              className="plusBtn"
                                              onClick={(event) =>
                                                addEditMaintaince(event, index)
                                              }
                                            >
                                              <AddIcon />
                                            </Button>
                                          ) : (
                                            <Button
                                              className="plusBtn"
                                              onClick={(event) =>
                                                addMoreMaintaince(event, index)
                                              }
                                            >
                                              <AddIcon />
                                            </Button>
                                          )
                                        ) : null}
                                      </Grid>
                                    </div>
                                  ))}
                                </div>
                              </Grid>
                            </Grid>
                          </div>

                          <div className="totalCalculation">
                            <div className="totalLab">Maintenance Total</div>
                            <div className="totalamt">
                              <CurrencyRupeeIcon />{" "}
                              <div id="subTotal" className="totalamt">
                                {maintenenceTotal}
                              </div>
                            </div>
                          </div>

                          {taxJsonList.map((option, index) => (
                            <Grid
                              container
                              spacing={3}
                              className="taxfiled botSpfild"
                            >
                              <Grid item xs={12} md={6}>
                                <input
                                  className="inputSt"
                                  value={option.key}
                                  name="taxcalnames"
                                />
                              </Grid>
                              <Grid item xs={12} md={3}>
                                <div className="inputWithICon">
                                  <PercentSharpIcon />
                                  {/* {option.key=="Late Fee" ?
                                    <input
                                    className="inputSt"
                                    value={option.value}
                                    onChange={(e)=> handleEditLatefee(e,index)}
                                    // onChange={event=>handleEditMaintenencevalue(event, index)}
                                    // onKeyUp={event=>calMissCharges(event, index)}
                                  />: */}
                                  <input
                                    className="inputSt visiblInput"
                                    value={option.value}
                                    // onChange={(e)=> handleEditLatefee(e,index)}
                                    onBlur={(event) =>
                                      numbertaxfloat(event, index, option.key)
                                    }
                                    onChange={(event) =>
                                      handleTaxMaintenances(event, index)
                                    }
                                  />
                                </div>
                              </Grid>
                              <Grid item xs={12} md={3}>
                                <div className="inputWithICon">
                                  <CurrencyRupeeIcon />
                                  <input
                                    className="inputSt"
                                    value={parseFloat(option.total).toFixed(2)}
                                    name="taxcalamts"
                                  />
                                </div>
                              </Grid>
                            </Grid>
                          ))}

                          <Grid container spacing={3}>
                            <Grid item xs={12} md={4}>
                              <label className="tabsLabel">Sub Total</label>
                              <div className="inputWithICon greenTextFildSVG">
                                <CurrencyRupeeIcon />
                                <input
                                  className="inputSt greenTextFild"
                                  placeholder="7000"
                                  readOnly={true}
                                  value={parseFloat(hiddentotalPayable).toFixed(
                                    2
                                  )}
                                  //subTotal
                                />
                              </div>
                            </Grid>
                            <Grid item xs={12} md={4}>
                              <label className="tabsLabel">
                                Advance Received
                              </label>
                              <div className="inputWithICon greenTextFildSVG">
                                <CurrencyRupeeIcon />
                                <input
                                  className="inputSt greenTextFild"
                                  placeholder="3000"
                                  id="advanceReceived"
                                  name="advanceReceived"
                                  value={advanceReceived}
                                  maxLength={8}
                                  onChange={(event) =>
                                    handleadvanceChange(event)
                                  }
                                  onBlur={(event) => numberdecimal(event)}
                                  onKeyUp={(event) => advanceamt(event)}
                                />
                                {errors.advanceReceived &&
                                touched.advanceReceived ? (
                                  <div
                                    style={{ color: "red" }}
                                    className="errorField "
                                  >
                                    {errors.advanceReceived}
                                  </div>
                                ) : null}
                              </div>
                            </Grid>

                            <Grid item xs={12} md={4}>
                              <label className="tabsLabel">Total Payable</label>
                              <div className="inputWithICon greenTextFildSVG">
                                <CurrencyRupeeIcon />

                                <input
                                  type="hidden"
                                  className="inputSt greenTextFild"
                                  placeholder="4000"
                                  id="hiddentotalPayable"
                                  name="hiddentotalPayable"
                                  value={parseFloat(hiddentotalPayable).toFixed(
                                    2
                                  )}
                                />

                                <input
                                  className="inputSt greenTextFild"
                                  placeholder="4000"
                                  id="totalPayable"
                                  name="totalPayable"
                                  value={parseFloat(totalPayable).toFixed(2)}
                                />
                              </div>
                            </Grid>
                          </Grid>

                          <Grid container>
                            <Grid item xs={12} md={12}>
                              <h2 className="invoiceSubHeading">Notes</h2>
                            </Grid>
                            <Grid item xs={12} md={12}>
                              <input
                                className="inputSt"
                                placeholder="Notes"
                                // value={values.note}
                                value={notes}
                                onChange={handleChange("note")}
                                onBlur={() => setFieldTouched("note")}
                                onChangeCapture={(e) =>
                                  setNotes(e.target.value)
                                }
                              />
                            </Grid>
                          </Grid>

                          <Grid container>
                            <Grid
                              item
                              xs={12}
                              md={12}
                              className="previewBtOuter"
                            >
                            {/* {(createInvoiceFalg=== true && !isEditMonthlyInvoice) && (
                              <Button
                                className="addBt PreviewBtn"
                                onClick={() => saveInvoice()}
                              >
                                {isEditMonthlyInvoice ? (
                                  <>Edit Monthly Invoice</>
                                ) : (
                                  <>Save Invoice</>
                                )}
                              </Button>
                            )} */}

{(!isEditMonthlyInvoice && createInvoiceFalg) && (
  <Button
    className="addBt PreviewBtn"
    onClick={() => saveInvoice()}
  >
    Save Invoice
  </Button>
)}

{isEditMonthlyInvoice && (
  <Button
    className="addBt PreviewBtn"
    onClick={() => saveInvoice()}
  >
    Edit Monthly Invoice
  </Button>
)}
                            </Grid>
                          </Grid>
                        </div>
                      </div>
                    </Form>
                  )}
                </Formik>
              </div>
            </TabPanel>

            <TabPanel value={value} index={1}>
              <div>
                <Formik
                  enableReinitialize
                  initialValues={formikInitials}
                  validationSchema={Validation_Schema}
                  onSubmit={saveInvoice}
                >
                  {({
                    values,
                    handleChange,
                    errors,
                    setFieldTouched,
                    touched,
                    isValid,
                    handleSubmit,
                  }) => (
                    <Form>
                      <div className="invoiceMain">
                        <div className="invoiceInnerMain">
                          <Grid container spacing={3}>
                            <Grid item xs={12} md={4}>
                              <input
                                className="inputSt"
                                placeholder="Search by Name"
                                onChangeCapture={(e) => setQ(e.target.value)}
                              />
                            </Grid>
                            <Grid item xs={12} md={4}>
                              <select
                                className="inputSt"
                                value={selectedOwner}
                                onChange={(e) =>
                                  handlechangeOwner(e.target.value)
                                }
                                onBlur={() => setFieldTouched("selectedOwner")}
                              >
                                <option>Select Owner</option>
                                {ownersList.map((option) => (
                                  <option
                                    key={option.resident_id}
                                    value={option.resident_id}
                                    data-isd={
                                      option.user_obj.first_name +
                                      " " +
                                      option.user_obj.last_name
                                    }
                                  >
                                    {option.user_obj.first_name +
                                      " " +
                                      option.user_obj.last_name}
                                  </option>
                                ))}
                              </select>
                              {errors.selectedOwner && touched.selectedOwner ? (
                                <div
                                  style={{ color: "red" }}
                                  className="errorField"
                                >
                                  {errors.selectedOwner}
                                </div>
                              ) : null}
                            </Grid>
                            <Grid item xs={12} md={4}>
                              <select
                                className="inputSt"
                                name="selectmissApartdrop"
                                id="selectmissApartdrop"
                                value={selectedApartment}
                                onChange={(e) =>
                                  handlechangeApartment(
                                    e.target.value,
                                    "Miscellaneous"
                                  )
                                }
                              >
                                <option value="">Select Apartment</option>
                                {apartmentList.map((option) => (
                                  <option
                                    key={option.apartment_id}
                                    value={option.apartment_id}
                                    data-isd={option.uniq_apt_name}
                                  >
                                    {option.uniq_apt_name}
                                  </option>
                                ))}
                              </select>
                            </Grid>
                          </Grid>

                          <Grid container>
                            <Grid item xs={12} md={12}>
                              <h2 className="invoiceSubHeading">
                                Create Invoice
                              </h2>
                            </Grid>
                          </Grid>

                          <Grid container spacing={3}>
                            <Grid item xs={12} md={4}>
                              <label className="tabsLabel">Invoice #</label>
                              <input
                                className="inputSt"
                                placeholder="267345"
                                value={invoiceNo}
                              />
                            </Grid>
                            <Grid item xs={12} md={4}>
                              <label className="tabsLabel">Invoice Date</label>
                              <div className="dateTimeMain">
                                <LocalizationProvider
                                  dateAdapter={AdapterDayjs}
                                >
                                  <Stack className="inputSt">
                                    <DesktopDatePicker
                                      inputFormat="MM/DD/YYYY"
                                      value={invoice_date}
                                      onChange={handleInvoiceDate}
                                      renderInput={(params) => (
                                        <TextField {...params} />
                                      )}
                                    />
                                  </Stack>
                                </LocalizationProvider>
                              </div>
                            </Grid>
                            <Grid item xs={12} md={4}>
                              <label className="tabsLabel">Due Date</label>
                              <div className="dateTimeMain">
                                <LocalizationProvider
                                  dateAdapter={AdapterDayjs}
                                >
                                  <Stack className="inputSt">
                                    <DesktopDatePicker
                                      inputFormat="MM/DD/YYYY"
                                      value={due_date}
                                      onChange={handleDueDate}
                                      renderInput={(params) => (
                                        <TextField {...params} />
                                      )}
                                    />
                                  </Stack>
                                </LocalizationProvider>
                              </div>
                            </Grid>
                            <Grid item xs={12} md={12}>
                              <input
                                className="inputSt"
                                placeholder="Subject"
                                value={values.subject}
                                onChange={handleChange("subject")}
                                onBlur={() => setFieldTouched("subject")}
                                onChangeCapture={(e) =>
                                  setSubject(e.target.value)
                                }
                              />
                              {errors.subject && touched.subject ? (
                                <div
                                  style={{ color: "red" }}
                                  className="errorField"
                                >
                                  {errors.subject}
                                </div>
                              ) : null}
                              <Grid item xs={12} md={12}></Grid>
                            </Grid>
                          </Grid>

                          <Grid container>
                            <Grid item xs={12} md={12}>
                              <h2 className="invoiceSubHeading">Bill to</h2>
                            </Grid>
                          </Grid>

                          <Grid container spacing={3}>
                            <Grid item xs={12} md={4}>
                              <input
                                type="text"
                                className="inputSt"
                                placeholder="Jarome Bell"
                                disabled
                                value={billto}
                              />
                            </Grid>
                            <Grid item xs={12} md={4}>
                              <input
                                className="inputSt"
                                placeholder="WIng-B"
                                disabled
                                value={apartmentNo.split("/")[1]}
                              />
                            </Grid>
                            <Grid item xs={12} md={4}>
                              <input
                                className="inputSt"
                                placeholder="Flat No. 204"
                                disabled
                                value={apartmentNo}
                              />
                            </Grid>
                            <Grid item xs={12} md={4}>
                              <div className="inputWithICon">
                                <LocalPhoneIcon />
                                <input
                                  className="inputSt"
                                  placeholder="9823898485"
                                  disabled
                                  value={contactNo}
                                />
                              </div>
                            </Grid>
                            <Grid item xs={12} md={4}>
                              <div className="inputWithICon">
                                <MailOutlineIcon />
                                <input
                                  className="inputSt"
                                  placeholder="sample@gmail.com"
                                  disabled
                                  value={emailId}
                                />
                              </div>
                            </Grid>
                          </Grid>

                          <div className="addAminitiesMainNew">
                            <Grid container spacing={3}>
                              <Grid item xs={12} md={12}>
                                <div className="showingAminitiesNew">
                                  <Grid container>
                                    <Grid item xs={12} md={12}>
                                      <h2 className="invoiceSubHeading">
                                        Invoice Details
                                      </h2>
                                    </Grid>
                                  </Grid>

                                  {mischJsonList.map((option, index) => (
                                    <div
                                      className="addedAppendLine"
                                      id="deleteId"
                                    >
                                      <Grid container spacing={3}>
                                        <Grid item xs={12} md={3}>
                                          <input
                                            className="inputSt"
                                            placeholder="Maintenence Name"
                                            name="name"
                                            value={option.name}
                                            onChange={(event) =>
                                              handleMissMaintenencevalue(
                                                event,
                                                index
                                              )
                                            }
                                          />
                                        </Grid>
                                        <Grid item xs={12} md={3}>
                                          <div className="inputWithICon splitStOut">
                                            <div>
                                              <CurrencyRupeeIcon />
                                              <input
                                                className="inputSt"
                                                placeholder="Amount"
                                                id="misch_amt"
                                                name="amount"
                                                value={option.amount}
                                                onChange={(event) =>
                                                  handleMissvalueChange(
                                                    event,
                                                    index
                                                  )
                                                }
                                                maxLength={8}
                                                onBlur={(event) =>
                                                  numbertodecimal(event, index)
                                                }
                                                onKeyUp={(event) =>
                                                  calMissCharges(event, index)
                                                }
                                              />
                                            </div>
                                            <div className="splitOption">
                                              <select
                                                id="misch_duration_key"
                                                name="duration_key"
                                                value={option.duration_key}
                                                onChange={(e) =>
                                                  handleMissDurationKey(
                                                    e,
                                                    index
                                                  )
                                                }
                                              >
                                                <option value="" disabled>
                                                  Duration
                                                </option>
                                                <option value="/hour">
                                                  / hour
                                                </option>
                                                <option value="/day">
                                                  / day
                                                </option>
                                              </select>
                                            </div>
                                          </div>
                                        </Grid>

                                        <Grid item xs={12} md={3}>
                                          <div className="inputWithICon splitStOut">
                                            <div>
                                              <input
                                                className="inputSt durationField"
                                                placeholder="Duration"
                                                id="misch_duration"
                                                name="duration"
                                                value={option.duration}
                                                onChange={(event) =>
                                                  handleMissDuration(
                                                    event,
                                                    index
                                                  )
                                                }
                                                maxLength={8}
                                                onKeyUp={(event) =>
                                                  calMissCharges(event, index)
                                                }
                                              />
                                            </div>
                                            <div className="splitOption hrsSt">
                                              {option.duration_key ? (
                                                <>
                                                  {option.duration_key ==
                                                  "/hour" ? (
                                                    <>Hours</>
                                                  ) : (
                                                    <>Days</>
                                                  )}
                                                </>
                                              ) : (
                                                <></>
                                              )}
                                            </div>
                                          </div>
                                        </Grid>
                                        <Grid item xs={12} md={3}>
                                          <div className="inputWithICon">
                                            <CurrencyRupeeIcon />
                                            <input
                                              className="inputSt"
                                              placeholder="Total"
                                              name="total"
                                              value={option.total}
                                            />
                                          </div>
                                        </Grid>
                                        {mischJsonList.length > 1 &&
                                        mischJsonList.length - 1 != index ? (
                                          <Button className="minusBtnNew">
                                            <RemoveIcon
                                              // onClick={() =>
                                              //   handleClickMinus(index)
                                              // }

                                              onClick={(event) =>
                                                removeMissMaintaince(
                                                  event,
                                                  index
                                                )
                                              }
                                            />
                                          </Button>
                                        ) : null}
                                        {mischJsonList.length - 1 === index ? (
                                          <Button
                                            className="plusBtn"
                                            onClick={(event) =>
                                              handleChangeMiscellaneous(
                                                event,
                                                index
                                              )
                                            }
                                          >
                                            <AddIcon />
                                          </Button>
                                        ) : null}
                                      </Grid>
                                    </div>
                                  ))}
                                </div>
                              </Grid>
                            </Grid>
                          </div>

                          <div className="totalCalculation">
                            <div className="totalLab">Maintenance Total</div>
                            <div className="totalamt">
                              <CurrencyRupeeIcon />
                              <div id="subTotal" className="totalamt">
                                {maintenenceTotal}
                              </div>
                            </div>
                          </div>
                          <div className="clear"></div>
                          <div
                            className="addAminitiesMain noPad"
                            id="addAminitiesId"
                          >
                            <Grid container>
                              <Grid item xs={12} md={12}>
                                <div className="showingAminities">
                                  <Grid container>
                                    <Grid item xs={12} md={12}>
                                      <h2 className="invoiceSubHeading">
                                        Other Maintenence Details
                                      </h2>
                                    </Grid>
                                  </Grid>

                                  <div className="appendLine">
                                    <Grid container spacing={3}>
                                      <Grid item xs={12} md={8}>
                                        <input
                                          className="inputSt"
                                          placeholder="Maintenence Name"
                                        />
                                      </Grid>
                                      <Grid item xs={12} md={4}>
                                        <div className="inputWithICon">
                                          <CurrencyRupeeIcon />
                                          <input
                                            className="inputSt"
                                            placeholder="Amount"
                                          />
                                        </div>
                                      </Grid>
                                    </Grid>
                                    <Button
                                      className="plusBtn"
                                      // onClick={() => setCount2(count + 1)}
                                    >
                                      {" "}
                                      Other
                                      <AddIcon />
                                    </Button>
                                  </div>
                                </div>
                              </Grid>
                            </Grid>
                          </div>

                          {/* misch */}
                          {taxJsonList.map((option, index) => (
                            <Grid
                              container
                              spacing={3}
                              className="taxfiled botSpfild"
                            >
                              <Grid item xs={12} md={6}>
                                <input className="inputSt" value={option.key} />
                              </Grid>
                              <Grid item xs={12} md={3}>
                                <div className="inputWithICon">
                                  <PercentSharpIcon />
                                  <input
                                    className="inputSt visiblInput"
                                    value={option.value}
                                    onBlur={(event) =>
                                      numbertaxfloatmis(
                                        event,
                                        index,
                                        option.key
                                      )
                                    }
                                    onChange={(event) =>
                                      handleTaxMaintenancesmis(event, index)
                                    }
                                  />
                                </div>
                              </Grid>
                              <Grid item xs={12} md={3}>
                                <div className="inputWithICon">
                                  <CurrencyRupeeIcon />
                                  <input
                                    className="inputSt"
                                    value={parseFloat(option.total).toFixed(2)}
                                    name="taxcalamts"
                                  />
                                </div>
                              </Grid>
                            </Grid>
                          ))}

                          <Grid container spacing={3}>
                            <Grid item xs={12} md={4}>
                              <label className="tabsLabel">Sub Total</label>
                              <div className="inputWithICon greenTextFildSVG">
                                <CurrencyRupeeIcon />
                                <input
                                  className="inputSt greenTextFild"
                                  placeholder="7000"
                                  disabled
                                  value={parseFloat(
                                    hiddenmisstotalPayable
                                  ).toFixed(2)}
                                  //subTotal
                                />
                              </div>
                            </Grid>
                            <Grid item xs={12} md={4}>
                              <label className="tabsLabel">
                                Advance Received
                              </label>
                              <div className="inputWithICon greenTextFildSVG">
                                <CurrencyRupeeIcon />
                                <input
                                  className="inputSt greenTextFild"
                                  placeholder="3000"
                                  id="advanceReceived"
                                  name="advanceReceived"
                                  value={advanceReceived}
                                  maxLength={8}
                                  onChange={(event) =>
                                    handleadvanceChange(event)
                                  }
                                  onBlur={(event) => numberdecimal(event)}
                                  onKeyUp={(event) => advanceamt(event)}

                                  // value={parseFloat(advanceReceived).toFixed(2)}
                                  // onChange={handleChange("advanceReceived")}
                                  // onBlur={() =>
                                  //   setFieldTouched("advanceReceived")
                                  // }
                                  // onChangeCapture={(e) =>
                                  //   handleAdvanceReceived(e.target.value)
                                  // }
                                />
                                {errors.advanceReceived &&
                                touched.advanceReceived ? (
                                  <div
                                    style={{ color: "red" }}
                                    className="errorField"
                                  >
                                    {errors.advanceReceived}
                                  </div>
                                ) : null}
                              </div>
                            </Grid>
                            <Grid item xs={12} md={4}>
                              <label className="tabsLabel">Total Payable</label>
                              <div className="inputWithICon greenTextFildSVG">
                                <CurrencyRupeeIcon />
                                <input
                                  type="hidden"
                                  className="inputSt greenTextFild"
                                  placeholder="4000"
                                  id="hiddentotalPayable"
                                  name="hiddentotalPayable"
                                  value={parseFloat(
                                    hiddenmisstotalPayable
                                  ).toFixed(2)}
                                />
                                <input
                                  className="inputSt greenTextFild"
                                  placeholder="4000"
                                  id="totalPayable"
                                  name="totalPayable"
                                  value={parseFloat(totalPayable).toFixed(2)}
                                />
                              </div>
                            </Grid>

                            <Grid item xs={12} md={12}>
                              <h2 className="invoiceSubHeading marginTpMins">
                                Notes
                              </h2>
                              <input
                                className="inputSt"
                                placeholder="Notes"
                                value={values.note}
                                onChange={handleChange("note")}
                                onBlur={() => setFieldTouched("note")}
                                onChangeCapture={(e) =>
                                  setNotes(e.target.value)
                                }
                              />
                            </Grid>
                          </Grid>

                          <Grid container>
                            <Grid
                              item
                              xs={12}
                              md={12}
                              className="previewBtOuter"
                            >
                            {/* {createInvoiceFalg && */}
                              <Button
                                className="addBt PreviewBtn"
                                onClick={() => saveInvoice()}
                              >
                                Save Invoice
                              </Button>
                  
                            </Grid>
                          </Grid>
                        </div>
                      </div>
                    </Form>
                  )}
                </Formik>
              </div>
            </TabPanel>
          </Box>
        </div>
      </div>

      {showLoader ? (
        <div className="loaderOter" id="loaderId">
          <div className="wrapper">
            <div className="circle"></div>
            <div className="circle"></div>
            <div className="circle"></div>
            <div className="shadow"></div>
            <div className="shadow"></div>
            <div className="shadow"></div>
            <span>Loading</span>
          </div>
        </div>
      ) : (
        <></>
      )}
    </>
  );
}

export default TabForCreateInvoice;
